<div class="bg-gray-900">
  <div class="flex h-[calc(100vh-64px)] overflow-hidden">
    <!-- Left Sidebar: Component Library + Layers -->
    <div data-tour="left-sidebar" class="w-64 bg-gray-800 border-r border-gray-700 flex flex-col">
      <!-- Tab Switcher -->
      <div class="flex border-b border-gray-700">
        <button
          data-tour="components-tab-btn"
          (click)="leftSidebarTab = 'components'"
          class="flex-1 px-4 py-3 text-sm font-medium transition-colors"
          [ngClass]="leftSidebarTab === 'components' ? 'text-white border-b-2 border-indigo-500 bg-gray-750' : 'text-gray-400 hover:text-gray-200'">
          <div class="flex items-center justify-center gap-1.5">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Componenten
          </div>
        </button>
        <button
          (click)="leftSidebarTab = 'layers'"
          class="flex-1 px-4 py-3 text-sm font-medium transition-colors"
          [ngClass]="leftSidebarTab === 'layers' ? 'text-white border-b-2 border-indigo-500 bg-gray-750' : 'text-gray-400 hover:text-gray-200'">
          <div class="flex items-center justify-center gap-1.5">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            Layers
          </div>
        </button>
      </div>

      <!-- Layers Tab -->
      <div *ngIf="leftSidebarTab === 'layers'" class="flex-1 overflow-y-auto">
        <div *ngIf="!currentPage?.components?.length" class="p-4 text-center">
          <p class="text-sm text-gray-500">Geen componenten</p>
        </div>
        <div *ngIf="currentPage?.components?.length" class="py-1">
          <div *ngFor="let component of currentPage!.components; let i = index">
            <!-- Layer item -->
            <button
              (click)="selectComponent(i)"
              class="w-full flex items-center gap-2 px-3 py-2 text-left text-sm transition-colors group"
              [ngClass]="selectedComponentIndex === i ? 'bg-indigo-600/20 text-white border-l-2 border-indigo-500' : 'text-gray-300 hover:bg-gray-700/50 border-l-2 border-transparent'">
              <svg class="w-3.5 h-3.5 flex-shrink-0 opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <ng-container [ngSwitch]="component.type">
                  <path *ngSwitchCase="'title'" stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h7" />
                  <path *ngSwitchCase="'text'" stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  <path *ngSwitchCase="'media-gallery'" stroke-linecap="round" stroke-linejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  <path *ngSwitchCase="'grid'" stroke-linecap="round" stroke-linejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  <path *ngSwitchCase="'products'" stroke-linecap="round" stroke-linejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  <path *ngSwitchCase="'news'" stroke-linecap="round" stroke-linejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                  <path *ngSwitchCase="'action'" stroke-linecap="round" stroke-linejoin="round" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                  <path *ngSwitchCase="'html-block'" stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                  <path *ngSwitchDefault stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
                </ng-container>
              </svg>
              <span class="truncate">{{ getComponentTypeName(component.type) }}</span>
              <span *ngIf="component.data['title'] || component.data['heading']" class="ml-auto text-[10px] text-gray-500 truncate max-w-[80px]">
                {{ component.data['title'] || component.data['heading'] }}
              </span>
            </button>
            <!-- Grid children (nested layers) -->
            <div *ngIf="component.type === 'grid' && component.data['cells']?.length">
              <div *ngFor="let cell of component.data['cells']; let ci = index">
                <div *ngFor="let child of cell.components || []; let chi = index">
                  <button
                    (click)="selectComponent(i); onGridCellSelected({ cellIndex: ci, componentIndex: chi })"
                    class="w-full flex items-center gap-2 pl-8 pr-3 py-1.5 text-left text-xs transition-colors"
                    [ngClass]="selectedComponentIndex === i && selectedGridCellIndex === ci && selectedCellComponentIndex === chi ? 'bg-indigo-600/15 text-indigo-300' : 'text-gray-500 hover:bg-gray-700/30 hover:text-gray-300'">
                    <svg class="w-3 h-3 flex-shrink-0 opacity-40" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                    <span class="truncate">{{ getComponentTypeName(child.type) }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Components Tab -->
      <div *ngIf="leftSidebarTab === 'components'" class="flex-1 overflow-y-auto p-4">
        <div class="space-y-2 component-library">
          <div 
            *ngFor="let component of availableComponents"
            (click)="addComponent(component.id)"
            class="bg-gray-700 hover:bg-gray-600 rounded-lg p-4 cursor-pointer transition-colors border border-gray-600 hover:border-indigo-500 component-item">
            <div class="flex items-center space-x-3">
              <div class="flex-shrink-0 text-gray-300">
                <ng-container [ngSwitch]="component.icon">
                  <!-- Heading Icon (for title) -->
                  <svg *ngSwitchCase="'heading'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7"></path>
                  </svg>
                  <!-- Document Text Icon -->
                  <svg *ngSwitchCase="'document-text'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  <!-- Cube Icon (for products) -->
                  <svg *ngSwitchCase="'cube'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                  </svg>
                  <!-- View Grid Icon -->
                  <svg *ngSwitchCase="'view-grid'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
                  </svg>
                  <!-- Photograph Icon (for gallery) -->
                  <svg *ngSwitchCase="'photograph'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  <!-- Newspaper Icon (for news) -->
                  <svg *ngSwitchCase="'newspaper'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path>
                  </svg>
                  <!-- Briefcase Icon (for projects) -->
                  <svg *ngSwitchCase="'briefcase'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                  </svg>
                  <!-- Clipboard List Icon (for form) -->
                  <svg *ngSwitchCase="'clipboard-list'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                  </svg>
                  <!-- Map Pin Icon (for map) -->
                  <svg *ngSwitchCase="'map-pin'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                  <!-- Code Icon (for html-block) -->
                  <svg *ngSwitchCase="'code'" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
                  </svg>
                  <!-- Default Icon -->
                  <svg *ngSwitchDefault class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                  </svg>
                </ng-container>
              </div>
              <div>
                <h3 class="text-sm font-medium text-white">{{ component.name }}</h3>
                <p class="text-xs text-gray-400 mt-1">{{ component.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Center: Preview Area -->
    <div *ngIf="currentPage" class="flex-1 flex flex-col overflow-hidden">
      <!-- Header -->
      <div class="bg-gray-800 border-b border-gray-700 px-6 py-4">
        <div class="flex justify-between items-center">
          <div class="space-y-1">
            <div class="flex items-center space-x-2">
              <input 
                type="text" 
                [(ngModel)]="currentPage.title"
                (ngModelChange)="updatePageTitle($event)"
                class="text-lg font-semibold bg-transparent text-white border-b border-transparent 
                       hover:border-gray-700 focus:border-indigo-500 focus:outline-none px-1 py-0.5
                       transition-colors"
                [placeholder]="'Voer ' + currentLocale.toUpperCase() + ' titel in'">
            </div>
            <div class="flex items-center mt-1">
              <span class="text-xs text-gray-500">/</span>
              <input 
                #urlInput
                type="text" 
                [value]="currentPage.route || ''"
                (input)="updatePageRoute(urlInput.value)"
                class="text-xs bg-transparent text-gray-500 border-b border-transparent 
                       hover:border-gray-700 focus:border-indigo-500 focus:outline-none px-1
                       transition-colors w-24"
                [placeholder]="'url-slug'">
            </div>
          </div>
          
          <div data-tour="top-actions" class="flex items-center space-x-4">
            <!-- Template Type Selector -->
            <!-- <div class="relative">
              <select 
                [(ngModel)]="currentPage.templateType"
                (ngModelChange)="updateTemplateType($event)"
                class="appearance-none block rounded-lg bg-gray-700 border-transparent px-4 py-2 pr-8 text-sm text-gray-200 
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20 
                  transition-colors duration-200">
                <option *ngFor="let type of templateTypes" [value]="type.id">{{ type.name }}</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
                <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div> -->
            
            <a *ngIf="previewUrl"
              [href]="previewUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center rounded-md border border-gray-600 hover:border-gray-500 px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-colors"
              title="Open preview op Vercel met domein-override (geen cache)">
              <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Bekijk preview
            </a>

            <button (click)="savePage()"
              class="inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-600">
              <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
              </svg>
              Opslaan
            </button>
            
            <button (click)="closeEditor()"
              class="inline-flex items-center rounded-md bg-gray-700 px-4 py-2 text-sm font-semibold text-gray-200 shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-gray-500">
              <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              Sluiten
            </button>
          </div>
        </div>
      </div>

      <!-- Categories Section (only for posts template) -->
      <div *ngIf="currentPage.templateType === 'posts'" class="bg-gray-800 border-b border-gray-700 px-6 py-4">
        <div class="space-y-4">
          <div>
            <h3 class="text-sm font-medium text-gray-200">Post Categorieën</h3>
            <p class="mt-1 text-xs text-gray-400">Selecteer welke categorieën van posts op deze pagina moeten worden weergegeven</p>
          </div>

          <div class="flex flex-wrap gap-2">
            <button
              *ngFor="let category of categories"
              (click)="toggleCategory(category.id)"
              class="group relative inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200"
              [class]="selectedCategories.includes(category.id) ? 
                'bg-indigo-600 text-white hover:bg-indigo-700' : 
                'bg-gray-700 text-gray-300 hover:bg-gray-600'">
              <span class="relative z-10">{{ category.name }}</span>
              <span *ngIf="selectedCategories.includes(category.id)" 
                class="ml-2 flex-shrink-0 h-3 w-3">
                <svg viewBox="0 0 20 20" fill="currentColor" class="transition-transform duration-200 transform group-hover:scale-110">
                  <path fill-rule="evenodd" 
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" 
                    clip-rule="evenodd" />
                </svg>
              </span>
            </button>
            
            <div *ngIf="categories.length === 0" 
              class="w-full flex items-center justify-center p-4 bg-gray-900 rounded-lg border border-gray-700">
              <div class="text-center">
                <p class="text-xs text-gray-400">Geen categorieën beschikbaar. Maak eerst categorieën aan in de posts sectie.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Preview Content Area -->
      <div data-tour="preview-area" class="flex-1 overflow-y-auto bg-gradient-to-br from-gray-50 to-gray-100 p-6 md:p-8 lg:p-12">
        <div class="max-w-5xl mx-auto">
          <!-- Preview Container -->
          <div class="bg-white rounded-xl shadow-2xl min-h-[600px] overflow-hidden" style="box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);">
            <!-- Empty State -->
            <div *ngIf="!currentPage.components || currentPage.components.length === 0" 
              class="flex flex-col items-center justify-center h-full min-h-[600px] text-center px-8">
              <div class="bg-gradient-to-br from-indigo-100 to-purple-100 rounded-full p-6 mb-6">
                <svg class="mx-auto h-16 w-16 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-2">Begin met je pagina</h3>
              <p class="text-sm text-gray-600 max-w-md">Selecteer een component uit het linker menu om te beginnen met het bouwen van je pagina</p>
            </div>

            <!-- Components Preview -->
            <div class="space-y-0">
              <div 
                *ngFor="let component of currentPage.components; let i = index"
                [attr.data-component-index]="i"
                (click)="selectComponent(i)"
                [class]="selectedComponentIndex === i ? 
                  'border-l-4 border-indigo-500 bg-indigo-50/50 relative transition-all duration-200' : 
                  'border-l-4 border-transparent hover:border-gray-200 hover:bg-gray-50/50 relative transition-all duration-200 cursor-pointer group'">
                
                <!-- Component Label (only on hover/select) -->
                <div *ngIf="selectedComponentIndex === i || (hoveredComponentIndex === i)" 
                     class="absolute top-2 right-2 z-20 bg-indigo-600 text-white text-xs font-medium px-2 py-1 rounded-md shadow-lg flex items-center gap-1">
                  <span>{{ getComponentInfo(component.type).name }}</span>
                  <button
                    (click)="removeComponent(i); $event.stopPropagation()"
                    class="ml-1 hover:bg-indigo-700 rounded p-0.5 transition-colors"
                    title="Verwijderen">
                    <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              
                <!-- Component Actions (on hover/select) -->
                <div *ngIf="selectedComponentIndex === i || (hoveredComponentIndex === i)" 
                     class="absolute left-2 top-2 z-20 flex flex-col gap-1">
                  <button
                    *ngIf="canMoveUp(i)"
                    (click)="moveComponentUp(i); $event.stopPropagation()"
                    class="p-1.5 rounded-md bg-white text-gray-700 hover:bg-gray-100 shadow-md border border-gray-200 transition-all"
                    title="Verplaats omhoog">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                    </svg>
                  </button>
                  <button
                    *ngIf="canMoveDown(i)"
                    (click)="moveComponentDown(i); $event.stopPropagation()"
                    class="p-1.5 rounded-md bg-white text-gray-700 hover:bg-gray-100 shadow-md border border-gray-200 transition-all"
                    title="Verplaats omlaag">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                </div>
                
                <!-- Component Content Wrapper -->
                <div class="px-6 py-8"
                     (mouseenter)="hoveredComponentIndex = i"
                     (mouseleave)="hoveredComponentIndex = null">
              
              <!-- Title Component Preview -->
              <div *ngIf="component.type === 'title'" class="py-8 px-6 relative bg-cover bg-center bg-no-repeat"
                [ngStyle]="getComponentBackgroundStyles(component)"
                [style.text-align]="component.data['alignment'] || 'center'">
                <!-- Overlay for image backgrounds -->
                <div *ngIf="component.data['backgroundType'] === 'image' && component.data['backgroundImage']"
                     class="absolute inset-0 bg-black/30 rounded-lg"></div>
                <div class="relative z-10">
                  <p *ngIf="component.data['subtitle'] && component.data['subtitlePosition'] === 'above'"
                     class="text-sm font-medium uppercase tracking-wider mb-2"
                     [style.color]="component.data['subtitleColor'] || (component.data['backgroundType'] === 'image' || component.data['backgroundType'] === 'theme' && (component.data['themeAccent'] === 'primary' || component.data['themeAccent'] === 'accent' || component.data['themeAccent'] === 'dark' || component.data['themeAccent'] === 'primary-gradient') ? '#ffffff' : '#6b7280')">
                    {{ component.data['subtitle'] || 'Subtitel' }}
                  </p>
                  <p class="font-bold tracking-tight"
                     [class]="(component.data['titleSize'] === '5xl' ? 'text-4xl' : component.data['titleSize'] === '4xl' ? 'text-3xl' : component.data['titleSize'] === '2xl' ? 'text-xl' : component.data['titleSize'] === 'xl' ? 'text-lg' : 'text-2xl')"
                     [style.color]="component.data['titleColor'] || (component.data['backgroundType'] === 'image' || component.data['backgroundType'] === 'theme' && (component.data['themeAccent'] === 'primary' || component.data['themeAccent'] === 'accent' || component.data['themeAccent'] === 'dark' || component.data['themeAccent'] === 'primary-gradient') ? '#ffffff' : '#111827')"
                     [style.font-weight]="component.data['titleWeight'] === 'extrabold' ? '800' : component.data['titleWeight'] === 'semibold' ? '600' : component.data['titleWeight'] === 'medium' ? '500' : component.data['titleWeight'] === 'normal' ? '400' : '700'">
                    {{ component.data['title'] || 'Titel tekst...' }}
                  </p>
                  <p *ngIf="component.data['subtitle'] && component.data['subtitlePosition'] !== 'above'"
                     class="text-base mt-2"
                     [style.color]="component.data['subtitleColor'] || (component.data['backgroundType'] === 'image' || component.data['backgroundType'] === 'theme' && (component.data['themeAccent'] === 'primary' || component.data['themeAccent'] === 'accent' || component.data['themeAccent'] === 'dark' || component.data['themeAccent'] === 'primary-gradient') ? '#ffffff' : '#6b7280')">
                    {{ component.data['subtitle'] }}
                  </p>
                  <div *ngIf="component.data['showDivider'] !== false" class="mt-4 h-1 rounded-full"
                       [style.width.px]="component.data['dividerWidth'] || 64"
                       [style.background-color]="component.data['dividerColor'] || '#2563eb'"
                       [style.margin-left]="component.data['alignment'] === 'center' ? 'auto' : component.data['alignment'] === 'right' ? 'auto' : '0'"
                       [style.margin-right]="component.data['alignment'] === 'center' ? 'auto' : '0'">
                  </div>
                </div>
              </div>

              <!-- Text Component Preview -->
              <app-text-component
                *ngIf="component.type === 'text'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                [editorConfig]="editorConfig"
                mode="preview"
                (contentChange)="onEditorChange($event)">
              </app-text-component>

              <!-- Products Component Preview -->
              <app-products-component
                *ngIf="component.type === 'products'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                [currentLocale]="currentLocale"
                mode="preview"
                (removeProduct)="onRemoveProduct($event, i)">
              </app-products-component>

              <!-- Grid Component Preview -->
              <app-grid-component
                *ngIf="component.type === 'grid'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                [currentLocale]="currentLocale"
                [domainOverride]="currentPage.domain"
                mode="preview"
                (cellSelected)="onGridCellSelected($event)"
                (addComponentToCell)="onAddComponentToGridCell($event)"
                (componentInCellSelected)="onComponentInCellSelected($event)">
              </app-grid-component>

              <!-- Media Gallery Component Preview -->
              <div [class.full-width-carousel]="component.type === 'media-gallery' && (component.data['layoutType'] === 'carousel' || component.data['layoutType'] === 'hero') && component.data['fullWidth'] === true">
                <app-media-gallery-component
                  *ngIf="component.type === 'media-gallery'"
                  [component]="component"
                  [isSelected]="selectedComponentIndex === i"
                  mode="preview">
                </app-media-gallery-component>
              </div>

              <!-- News Component Preview -->
              <app-news-component
                *ngIf="component.type === 'news'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                [currentLocale]="currentLocale"
                [domainOverride]="currentPage.domain"
                mode="preview">
              </app-news-component>

              <!-- Projects Component Preview -->
              <app-projects-component
                *ngIf="component.type === 'projects'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                [currentLocale]="currentLocale"
                mode="preview"
                (removeProject)="onRemoveProject($event, i)">
              </app-projects-component>

              <!-- Form Component Preview -->
              <app-form-component
                *ngIf="component.type === 'form'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                mode="preview"
                (contentChange)="debouncedSave()">
              </app-form-component>

              <!-- Map Component Preview -->
              <app-map-component
                *ngIf="component.type === 'map'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                mode="preview"
                (contentChange)="debouncedSave()">
              </app-map-component>

              <!-- HTML Block Preview -->
              <app-html-block-component
                *ngIf="component.type === 'html-block'"
                [component]="component"
                [isSelected]="selectedComponentIndex === i"
                mode="preview"
                (contentChange)="debouncedSave()"
                (styleChange)="debouncedSave()">
              </app-html-block-component>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Sidebar: Edit Panel -->
    <div 
      *ngIf="selectedComponentIndex !== null && currentPage && currentPage.components"
      class="w-80 bg-gray-800 border-l border-gray-700 flex flex-col">
      <div class="p-4 border-b border-gray-700">
        <!-- Back to Grid breadcrumb -->
        <button *ngIf="editingCellComponent" (click)="closeCellComponentEditor()"
          class="flex items-center gap-1.5 text-xs text-indigo-400 hover:text-indigo-300 mb-2 transition-colors">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Terug naar Grid
        </button>
        <div class="flex items-center justify-between">
          <h2 class="text-lg font-semibold text-white">{{ editingCellComponent ? 'Cel Component' : 'Component Bewerken' }}</h2>
          <button
            (click)="editingCellComponent ? closeCellComponentEditor() : deselectComponent()"
            class="text-gray-400 hover:text-white transition-colors">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p class="text-sm text-gray-400 mt-1">
          {{ getComponentInfo(getSelectedComponent()?.type || '').name }}
        </p>
      </div>

      <div class="flex-1 min-h-0 overflow-y-auto p-4 space-y-6">

        <!-- Title Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'title'" class="space-y-4">
          <!-- Title Text -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Titel</label>
            <input
              type="text"
              [value]="getSelectedComponent()?.data?.['title'] || ''"
              (input)="updateTextComponentField('title', $any($event.target).value)"
              placeholder="Voer titel in..."
              class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
          </div>

          <!-- Subtitle -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel</label>
            <input
              type="text"
              [value]="getSelectedComponent()?.data?.['subtitle'] || ''"
              (input)="updateTextComponentField('subtitle', $any($event.target).value)"
              placeholder="Optionele subtitel"
              class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
          </div>

          <!-- Subtitle Position -->
          <div *ngIf="getSelectedComponent()?.data?.['subtitle']">
            <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel Positie</label>
            <select
              [value]="getSelectedComponent()?.data?.['subtitlePosition'] || 'below'"
              (change)="updateTextComponentField('subtitlePosition', $any($event.target).value)"
              class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <option value="above">Boven de titel</option>
              <option value="below">Onder de titel</option>
            </select>
          </div>

          <!-- HTML Tag -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">HTML Tag</label>
            <select
              [value]="getSelectedComponent()?.data?.['titleTag'] || 'h2'"
              (change)="updateTextComponentField('titleTag', $any($event.target).value)"
              class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <option value="h1">H1</option>
              <option value="h2">H2</option>
              <option value="h3">H3</option>
              <option value="h4">H4</option>
              <option value="h5">H5</option>
              <option value="h6">H6</option>
            </select>
          </div>

          <!-- Title Size -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Titel Grootte</label>
            <select
              [value]="getSelectedComponent()?.data?.['titleSize'] || '3xl'"
              (change)="updateTextComponentField('titleSize', $any($event.target).value)"
              class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <option value="xl">Klein</option>
              <option value="2xl">Middel</option>
              <option value="3xl">Groot</option>
              <option value="4xl">Extra Groot</option>
              <option value="5xl">Mega</option>
            </select>
          </div>

          <!-- Title Weight -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Titel Dikte</label>
            <select
              [value]="getSelectedComponent()?.data?.['titleWeight'] || 'bold'"
              (change)="updateTextComponentField('titleWeight', $any($event.target).value)"
              class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <option value="normal">Normaal</option>
              <option value="medium">Medium</option>
              <option value="semibold">Semi Bold</option>
              <option value="bold">Bold</option>
              <option value="extrabold">Extra Bold</option>
            </select>
          </div>

          <!-- Alignment -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Uitlijning</label>
            <div class="flex rounded-lg overflow-hidden border border-gray-600">
              <button type="button"
                (click)="updateTextComponentField('alignment', 'left')"
                [class]="getSelectedComponent()?.data?.['alignment'] === 'left' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'"
                class="flex-1 py-2 text-xs font-medium transition-colors">Links</button>
              <button type="button"
                (click)="updateTextComponentField('alignment', 'center')"
                [class]="(getSelectedComponent()?.data?.['alignment'] || 'center') === 'center' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'"
                class="flex-1 py-2 text-xs font-medium transition-colors border-x border-gray-600">Midden</button>
              <button type="button"
                (click)="updateTextComponentField('alignment', 'right')"
                [class]="getSelectedComponent()?.data?.['alignment'] === 'right' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'"
                class="flex-1 py-2 text-xs font-medium transition-colors">Rechts</button>
            </div>
          </div>

          <!-- Title Color -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Titel Kleur</label>
            <div class="flex items-center space-x-2">
              <input
                type="color"
                [value]="getSelectedComponent()?.data?.['titleColor'] || '#111827'"
                (change)="updateTextComponentField('titleColor', $any($event.target).value)"
                class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
              <input
                type="text"
                [value]="getSelectedComponent()?.data?.['titleColor'] || ''"
                (input)="updateTextComponentField('titleColor', $any($event.target).value)"
                placeholder="Automatisch"
                class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <button *ngIf="getSelectedComponent()?.data?.['titleColor']"
                (click)="updateTextComponentField('titleColor', '')"
                class="p-2 text-gray-400 hover:text-white transition-colors" title="Reset">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Subtitle Color -->
          <div *ngIf="getSelectedComponent()?.data?.['subtitle']">
            <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel Kleur</label>
            <div class="flex items-center space-x-2">
              <input
                type="color"
                [value]="getSelectedComponent()?.data?.['subtitleColor'] || '#6b7280'"
                (change)="updateTextComponentField('subtitleColor', $any($event.target).value)"
                class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
              <input
                type="text"
                [value]="getSelectedComponent()?.data?.['subtitleColor'] || ''"
                (input)="updateTextComponentField('subtitleColor', $any($event.target).value)"
                placeholder="Automatisch"
                class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <button *ngIf="getSelectedComponent()?.data?.['subtitleColor']"
                (click)="updateTextComponentField('subtitleColor', '')"
                class="p-2 text-gray-400 hover:text-white transition-colors" title="Reset">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Divider -->
          <div class="border-t border-gray-700 pt-4">
            <label class="flex items-center space-x-2 cursor-pointer mb-3">
              <input
                type="checkbox"
                [checked]="getSelectedComponent()?.data?.['showDivider'] !== false"
                (change)="updateTextComponentField('showDivider', $any($event.target).checked)"
                class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
              <span class="text-sm font-medium text-gray-300">Scheidingslijn</span>
            </label>
            <div *ngIf="getSelectedComponent()?.data?.['showDivider'] !== false" class="space-y-3 ml-6">
              <div>
                <label class="block text-xs font-medium text-gray-400 mb-1">Breedte (px)</label>
                <input
                  type="range"
                  [value]="getSelectedComponent()?.data?.['dividerWidth'] || 64"
                  (input)="updateTextComponentField('dividerWidth', +$any($event.target).value)"
                  min="24" max="200" step="4"
                  class="w-full accent-indigo-500">
                <span class="text-xs text-gray-500">{{ getSelectedComponent()?.data?.['dividerWidth'] || 64 }}px</span>
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-400 mb-1">Kleur</label>
                <div class="flex items-center space-x-2">
                  <input
                    type="color"
                    [value]="getSelectedComponent()?.data?.['dividerColor'] || '#2563eb'"
                    (change)="updateTextComponentField('dividerColor', $any($event.target).value)"
                    class="h-8 w-14 rounded border border-gray-600 cursor-pointer">
                  <button *ngIf="getSelectedComponent()?.data?.['dividerColor']"
                    (click)="updateTextComponentField('dividerColor', '')"
                    class="text-xs text-gray-400 hover:text-white transition-colors">Reset</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Vertical Padding -->
          <div class="border-t border-gray-700 pt-4">
            <label class="block text-sm font-medium text-gray-300 mb-2">Verticale Padding</label>
            <input
              type="range"
              [value]="getSelectedComponent()?.data?.['paddingY'] ?? 48"
              (input)="updateTextComponentField('paddingY', +$any($event.target).value)"
              min="0" max="120" step="4"
              class="w-full accent-indigo-500">
            <span class="text-xs text-gray-500">{{ getSelectedComponent()?.data?.['paddingY'] ?? 48 }}px</span>
          </div>

          <!-- Styling Options (background etc.) -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- Styling Options -->
        <div *ngIf="getSelectedComponent()?.type === 'text'" class="space-y-6 border-t border-gray-700 pt-6">
          <!-- Text Content Editor (for grid cell editing) -->
          <div *ngIf="editingCellComponent" class="mb-4">
            <label class="block text-sm font-medium text-gray-300 mb-2">Tekst Content</label>
            <button (click)="openTextEditorModal()"
              class="w-full flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors">
              <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Tekst Bewerken
            </button>
            <div class="mt-2 text-xs text-gray-400">
              {{ (getSelectedComponent()?.data?.['content'] || '').length > 0 ? 'Bevat content (' + (getSelectedComponent()?.data?.['content'] || '').length + ' tekens)' : 'Nog geen content' }}
            </div>
          </div>

          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Styling Opties</h3>

            <!-- Title -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Titel</label>
              <input
                type="text"
                [value]="getSelectedComponent()?.data?.['heading'] || ''"
                (input)="updateTextComponentField('heading', $any($event.target).value)"
                placeholder="Sectie titel"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <!-- Subtitle -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel</label>
              <input
                type="text"
                [value]="getSelectedComponent()?.data?.['subtitle'] || ''"
                (input)="updateTextComponentField('subtitle', $any($event.target).value)"
                placeholder="Optionele subtitel"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <!-- Subtitle Position -->
            <div *ngIf="getSelectedComponent()?.data?.['subtitle']" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel Positie</label>
              <select
                [value]="getSelectedComponent()?.data?.['subtitlePosition'] || 'below'"
                (change)="updateTextComponentField('subtitlePosition', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="above">Boven de titel</option>
                <option value="below">Onder de titel</option>
              </select>
            </div>

            <!-- Title Position -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Titel Positie</label>
              <select
                [value]="getSelectedComponent()?.data?.['titlePosition'] || 'left'"
                (change)="updateTextComponentField('titlePosition', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="left">Links</option>
                <option value="center">Gecentreerd</option>
                <option value="right">Rechts</option>
              </select>
            </div>

            <!-- Background Type -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Achtergrond Type</label>
              <select
                [value]="getSelectedComponent()?.data?.['backgroundType'] || 'solid'"
                (change)="updateTextComponentField('backgroundType', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="solid">Vaste Kleur</option>
                <option value="theme">Thema Accent</option>
                <option value="gradient">Gradient</option>
                <option value="image">Afbeelding</option>
              </select>
            </div>

            <!-- Solid Color Background -->
            <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'solid'" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Achtergrond Kleur</label>
              <div class="flex items-center space-x-2">
                <input
                  type="color"
                  [value]="getSelectedComponent()?.data?.['backgroundColor'] || '#ffffff'"
                  (change)="updateTextComponentField('backgroundColor', $any($event.target).value)"
                  class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
                <input
                  type="text"
                  [value]="getSelectedComponent()?.data?.['backgroundColor'] || '#ffffff'"
                  (input)="updateTextComponentField('backgroundColor', $any($event.target).value)"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              </div>
            </div>

            <!-- Theme Accent Background -->
            <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'theme'" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Thema Accent</label>
              <p class="text-xs text-gray-400 mb-3">Kies een achtergrondkleur gebaseerd op je website thema. Past zich automatisch aan wanneer het thema wijzigt.</p>
              <div class="grid grid-cols-2 gap-2">
                <button type="button"
                  (click)="updateTextComponentField('themeAccent', 'primary')"
                  [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'primary'"
                  [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'primary'"
                  class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
                  <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: var(--primary-color, #2563eb)"></span>
                  <span class="text-xs text-gray-300">Primary</span>
                </button>
                <button type="button"
                  (click)="updateTextComponentField('themeAccent', 'accent')"
                  [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'accent'"
                  [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'accent'"
                  class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
                  <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: var(--accent-color, #0ea5e9)"></span>
                  <span class="text-xs text-gray-300">Accent</span>
                </button>
                <button type="button"
                  (click)="updateTextComponentField('themeAccent', 'primary-light')"
                  [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-light'"
                  [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-light'"
                  class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
                  <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: color-mix(in srgb, var(--primary-color, #2563eb) 12%, white)"></span>
                  <span class="text-xs text-gray-300">Primary Licht</span>
                </button>
                <button type="button"
                  (click)="updateTextComponentField('themeAccent', 'accent-light')"
                  [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'accent-light'"
                  [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'accent-light'"
                  class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
                  <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: color-mix(in srgb, var(--accent-color, #0ea5e9) 12%, white)"></span>
                  <span class="text-xs text-gray-300">Accent Licht</span>
                </button>
                <button type="button"
                  (click)="updateTextComponentField('themeAccent', 'dark')"
                  [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'dark'"
                  [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'dark'"
                  class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
                  <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: #111827"></span>
                  <span class="text-xs text-gray-300">Donker</span>
                </button>
                <button type="button"
                  (click)="updateTextComponentField('themeAccent', 'light')"
                  [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'light'"
                  [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'light'"
                  class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
                  <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: #f9fafb"></span>
                  <span class="text-xs text-gray-300">Licht Grijs</span>
                </button>
                <button type="button"
                  (click)="updateTextComponentField('themeAccent', 'primary-gradient')"
                  [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-gradient'"
                  [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-gradient'"
                  class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left col-span-2">
                  <span class="w-6 h-6 rounded-full flex-shrink-0" style="background: linear-gradient(135deg, var(--primary-color, #2563eb), var(--accent-color, #0ea5e9))"></span>
                  <span class="text-xs text-gray-300">Primary → Accent Gradient</span>
                </button>
              </div>
            </div>

            <!-- Gradient Background -->
            <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'gradient'" class="mb-4 space-y-3">
              <div>
                <label class="block text-sm font-medium text-gray-300 mb-2">Gradient Van</label>
                <div class="flex items-center space-x-2">
                  <input
                    type="color"
                    [value]="getSelectedComponent()?.data?.['gradientFrom'] || '#ffffff'"
                    (change)="updateTextComponentField('gradientFrom', $any($event.target).value)"
                    class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
                  <input
                    type="text"
                    [value]="getSelectedComponent()?.data?.['gradientFrom'] || '#ffffff'"
                    (input)="updateTextComponentField('gradientFrom', $any($event.target).value)"
                    class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                      hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                </div>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-300 mb-2">Gradient Naar</label>
                <div class="flex items-center space-x-2">
                  <input
                    type="color"
                    [value]="getSelectedComponent()?.data?.['gradientTo'] || '#ffffff'"
                    (change)="updateTextComponentField('gradientTo', $any($event.target).value)"
                    class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
                  <input
                    type="text"
                    [value]="getSelectedComponent()?.data?.['gradientTo'] || '#ffffff'"
                    (input)="updateTextComponentField('gradientTo', $any($event.target).value)"
                    class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                      hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                </div>
              </div>
            </div>

            <!-- Image Background -->
            <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'image'" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Achtergrond Afbeelding</label>
              <div class="space-y-2">
                <button
                  type="button"
                  (click)="openMediaSelector()"
                  class="w-full inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-600">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Selecteer uit Media Bibliotheek
                </button>
                <input
                  type="text"
                  [value]="getSelectedComponent()?.data?.['backgroundImage'] || ''"
                  (input)="updateTextComponentField('backgroundImage', $any($event.target).value)"
                  placeholder="Of voer URL in..."
                  class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <div *ngIf="getSelectedComponent()?.data?.['backgroundImage']" class="mt-2">
                  <img 
                    [src]="getSelectedComponent()?.data?.['backgroundImage']" 
                    alt="Preview"
                    class="w-full h-32 object-cover rounded-lg border border-gray-600">
                </div>
              </div>
            </div>

            <!-- Parallax (only for image background) -->
            <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'image'" class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['parallax'] || false"
                  (change)="updateTextComponentField('parallax', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Parallax Effect</span>
              </label>
              <p class="mt-1 text-xs text-gray-400">Maakt de achtergrond vast tijdens scrollen</p>
            </div>

            <!-- Kleuren -->
            <h4 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3 mt-6">Kleuren</h4>
            <p class="text-xs text-gray-500 mb-4">Laat leeg om de standaard theme-kleuren te gebruiken</p>

            <!-- Heading Color -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Titel Kleur</label>
              <div class="flex items-center space-x-2">
                <input
                  type="color"
                  [value]="getSelectedComponent()?.data?.['headingColor'] || '#111827'"
                  (change)="updateTextComponentField('headingColor', $any($event.target).value)"
                  class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
                <input
                  type="text"
                  [value]="getSelectedComponent()?.data?.['headingColor'] || ''"
                  (input)="updateTextComponentField('headingColor', $any($event.target).value)"
                  placeholder="Theme standaard"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <button *ngIf="getSelectedComponent()?.data?.['headingColor']"
                  type="button"
                  (click)="updateTextComponentField('headingColor', '')"
                  title="Reset naar theme standaard"
                  class="p-2 text-gray-400 hover:text-white transition-colors">
                  <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Subtitle Color -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel Kleur</label>
              <div class="flex items-center space-x-2">
                <input
                  type="color"
                  [value]="getSelectedComponent()?.data?.['subtitleColor'] || '#6b7280'"
                  (change)="updateTextComponentField('subtitleColor', $any($event.target).value)"
                  class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
                <input
                  type="text"
                  [value]="getSelectedComponent()?.data?.['subtitleColor'] || ''"
                  (input)="updateTextComponentField('subtitleColor', $any($event.target).value)"
                  placeholder="Theme standaard"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <button *ngIf="getSelectedComponent()?.data?.['subtitleColor']"
                  type="button"
                  (click)="updateTextComponentField('subtitleColor', '')"
                  title="Reset naar theme standaard"
                  class="p-2 text-gray-400 hover:text-white transition-colors">
                  <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Text Color -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Tekst Kleur</label>
              <div class="flex items-center space-x-2">
                <input
                  type="color"
                  [value]="getSelectedComponent()?.data?.['textColor'] || '#374151'"
                  (change)="updateTextComponentField('textColor', $any($event.target).value)"
                  class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
                <input
                  type="text"
                  [value]="getSelectedComponent()?.data?.['textColor'] || ''"
                  (input)="updateTextComponentField('textColor', $any($event.target).value)"
                  placeholder="Theme standaard"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <button *ngIf="getSelectedComponent()?.data?.['textColor']"
                  type="button"
                  (click)="updateTextComponentField('textColor', '')"
                  title="Reset naar theme standaard"
                  class="p-2 text-gray-400 hover:text-white transition-colors">
                  <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Products Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'products'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Producten Opties</h3>

            <!-- View Type -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Weergave Type</label>
              <select
                [value]="getSelectedComponent()?.data?.['viewType'] || 'grid'"
                (change)="updateTextComponentField('viewType', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="grid">Grid</option>
                <option value="list">Lijst</option>
              </select>
            </div>

            <!-- Columns (only for grid) -->
            <div *ngIf="(getSelectedComponent()?.data?.['viewType'] || 'grid') === 'grid'" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aantal Kolommen</label>
              <select
                [value]="getSelectedComponent()?.data?.['columns'] || 3"
                (change)="updateTextComponentField('columns', +$any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option [value]="1">1 Kolom</option>
                <option [value]="2">2 Kolommen</option>
                <option [value]="3">3 Kolommen</option>
                <option [value]="4">4 Kolommen</option>
              </select>
            </div>

            <!-- Limit -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aantal Producten</label>
              <input
                type="number"
                [value]="getSelectedComponent()?.data?.['limit'] || 0"
                (input)="updateTextComponentField('limit', +$any($event.target).value)"
                placeholder="0 = alle producten"
                min="0"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <p class="mt-1 text-xs text-gray-400">0 = alle producten tonen</p>
            </div>

            <!-- Show Price -->
            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showPrice'] !== false"
                  (change)="updateTextComponentField('showPrice', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Prijs Tonen</span>
              </label>
            </div>

            <!-- Show Description -->
            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showDescription'] !== false"
                  (change)="updateTextComponentField('showDescription', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Beschrijving Tonen</span>
              </label>
            </div>

            <!-- Product Selection -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Geselecteerde Producten</label>
              <button
                type="button"
                (click)="openProductSelector()"
                class="w-full inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-600">
                <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" />
                </svg>
                Selecteer Producten
              </button>
              <p *ngIf="(getSelectedComponent()?.data?.['selectedProductIds'] || []).length > 0" class="mt-2 text-xs text-gray-400">
                {{ (getSelectedComponent()?.data?.['selectedProductIds'] || []).length }} product{{ (getSelectedComponent()?.data?.['selectedProductIds'] || []).length !== 1 ? 'en' : '' }} geselecteerd
              </p>
              <p *ngIf="!(getSelectedComponent()?.data?.['selectedProductIds'] || []).length" class="mt-2 text-xs text-gray-400">
                Geen producten geselecteerd - alle producten worden getoond
              </p>
            </div>
          </div>

          <!-- Styling Options -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- Grid Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'grid'" data-sidebar-grid class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Grid Opties</h3>

            <!-- Columns -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aantal Kolommen</label>
              <select
                [value]="getSelectedComponent()?.data?.['columns'] || 3"
                (change)="updateTextComponentField('columns', +$any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option [value]="1">1 Kolom</option>
                <option [value]="2">2 Kolommen</option>
                <option [value]="3">3 Kolommen</option>
                <option [value]="4">4 Kolommen</option>
                <option [value]="5">5 Kolommen</option>
                <option [value]="6">6 Kolommen</option>
              </select>
            </div>

            <!-- Gap -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Tussenruimte (Gap)</label>
              <div class="flex items-center space-x-2">
                <input
                  type="number"
                  [value]="getSelectedComponent()?.data?.['gap'] || 16"
                  (input)="updateTextComponentField('gap', +$any($event.target).value)"
                  min="0"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <select
                  [value]="getSelectedComponent()?.data?.['gapUnit'] || 'px'"
                  (change)="updateTextComponentField('gapUnit', $any($event.target).value)"
                  class="rounded-lg bg-gray-700 border-transparent px-3 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                  <option value="px">px</option>
                  <option value="rem">rem</option>
                </select>
              </div>
            </div>

            <!-- Item Styling -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Item Padding</label>
              <input
                type="number"
                [value]="getSelectedComponent()?.data?.['itemPadding'] || 16"
                (input)="updateTextComponentField('itemPadding', +$any($event.target).value)"
                min="0"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Item Border Radius</label>
              <input
                type="number"
                [value]="getSelectedComponent()?.data?.['itemBorderRadius'] || 8"
                (input)="updateTextComponentField('itemBorderRadius', +$any($event.target).value)"
                min="0"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Item Achtergrond</label>
              <div class="flex items-center space-x-2">
                <input
                  type="color"
                  [value]="getSelectedComponent()?.data?.['itemBackgroundColor'] || '#f9fafb'"
                  (change)="updateTextComponentField('itemBackgroundColor', $any($event.target).value)"
                  class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
                <input
                  type="text"
                  [value]="getSelectedComponent()?.data?.['itemBackgroundColor'] || '#f9fafb'"
                  (input)="updateTextComponentField('itemBackgroundColor', $any($event.target).value)"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              </div>
            </div>

            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showItemBorder'] !== false"
                  (change)="updateTextComponentField('showItemBorder', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Item Border Tonen</span>
              </label>
            </div>
          </div>

          <!-- Grid Cells Management -->
          <div class="border-t border-gray-700 pt-4 mt-4">
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Grid Cellen</h3>

            <!-- Add Cell Button -->
            <button
              (click)="addGridCell()"
              class="w-full mb-4 flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors">
              <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Cel Toevoegen
            </button>

            <!-- Cells List -->
            <div *ngIf="(getSelectedComponent()?.data?.['cells'] || []).length > 0" class="space-y-2">
              <div *ngFor="let cell of getSelectedComponent()?.data?.['cells'] || []; let i = index"
                   class="flex items-center justify-between p-3 rounded-lg cursor-pointer transition-colors"
                   [ngClass]="selectedGridCellIndex === i ? 'bg-indigo-600/20 border border-indigo-500' : 'bg-gray-700 hover:bg-gray-600'"
                   (click)="onGridCellSelected({ cellIndex: i })">
                <div class="flex items-center">
                  <span class="w-6 h-6 bg-gray-600 text-white text-xs rounded-full flex items-center justify-center mr-3">
                    {{ i + 1 }}
                  </span>
                  <div>
                    <span class="text-sm text-gray-200">Cel {{ i + 1 }}</span>
                    <span class="text-xs text-gray-400 ml-2">{{ (cell.components || []).length }} component(en)</span>
                  </div>
                </div>
                <button
                  (click)="removeGridCell(i); $event.stopPropagation()"
                  class="p-1 text-gray-400 hover:text-red-400 transition-colors">
                  <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- No Cells Message -->
            <div *ngIf="(getSelectedComponent()?.data?.['cells'] || []).length === 0"
                 class="text-center py-4 text-gray-400 text-sm">
              Nog geen cellen. Klik op "Cel Toevoegen" om te beginnen.
            </div>
          </div>

          <!-- Selected Cell Options -->
          <div *ngIf="selectedGridCellIndex !== null && getSelectedGridCell()" class="border-t border-gray-700 pt-4 mt-4">
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Cel {{ selectedGridCellIndex + 1 }} Opties</h3>

            <!-- Col Span -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Kolom Span</label>
              <select
                [value]="getSelectedGridCell()?.colSpan || 1"
                (change)="updateGridCellField('colSpan', +$any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option [value]="1">1 Kolom</option>
                <option [value]="2">2 Kolommen</option>
                <option [value]="3">3 Kolommen</option>
                <option [value]="4">4 Kolommen</option>
              </select>
            </div>

            <!-- Row Span -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Rij Span</label>
              <select
                [value]="getSelectedGridCell()?.rowSpan || 1"
                (change)="updateGridCellField('rowSpan', +$any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option [value]="1">1 Rij</option>
                <option [value]="2">2 Rijen</option>
                <option [value]="3">3 Rijen</option>
              </select>
            </div>

            <!-- Add Component to Cell -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Component Toevoegen</label>
              <div class="grid grid-cols-2 gap-2">
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'text' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  Tekst
                </button>
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'media-gallery' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  Media
                </button>
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'products' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                  </svg>
                  Producten
                </button>
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'news' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path>
                  </svg>
                  Nieuws
                </button>
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'projects' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                  </svg>
                  Projecten
                </button>
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'form' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                  </svg>
                  Formulier
                </button>
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'map' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                  Kaart
                </button>
                <button
                  (click)="onAddComponentToGridCell({ cellIndex: selectedGridCellIndex, componentType: 'action' })"
                  class="flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm rounded-lg transition-colors">
                  <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"></path>
                  </svg>
                  Action
                </button>
              </div>
            </div>

            <!-- Cell Components List -->
            <div *ngIf="(getSelectedGridCell()?.components || []).length > 0">
              <label class="block text-sm font-medium text-gray-300 mb-2">Componenten in Cel</label>
              <p class="text-xs text-gray-400 mb-3">Klik op bewerken om een component aan te passen</p>
              <div class="space-y-2">
                <div *ngFor="let comp of getSelectedGridCell()?.components || []; let j = index"
                     class="flex items-center justify-between p-3 bg-gray-700 rounded-lg transition-colors"
                     [ngClass]="selectedCellComponentIndex === j ? 'ring-2 ring-indigo-500 bg-indigo-600/20' : ''">
                  <div class="flex items-center flex-1">
                    <ng-container [ngSwitch]="comp.type">
                      <svg *ngSwitchCase="'text'" class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                      </svg>
                      <svg *ngSwitchCase="'media-gallery'" class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                      </svg>
                      <svg *ngSwitchCase="'products'" class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                      </svg>
                      <svg *ngSwitchCase="'news'" class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path>
                      </svg>
                      <svg *ngSwitchDefault class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
                      </svg>
                    </ng-container>
                    <span class="text-sm text-gray-200 font-medium">{{ getComponentTypeName(comp.type) }}</span>
                  </div>
                  <div class="flex items-center gap-1">
                    <button *ngIf="j > 0"
                      (click)="moveCellComponentUp(selectedGridCellIndex!, j); $event.stopPropagation()"
                      class="p-1 text-gray-400 hover:text-gray-200 transition-colors"
                      title="Omhoog">
                      <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                      </svg>
                    </button>
                    <button *ngIf="j < (getSelectedGridCell()?.components || []).length - 1"
                      (click)="moveCellComponentDown(selectedGridCellIndex!, j); $event.stopPropagation()"
                      class="p-1 text-gray-400 hover:text-gray-200 transition-colors"
                      title="Omlaag">
                      <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    <button
                      (click)="openCellComponentEditor(j); $event.stopPropagation()"
                      class="p-1.5 text-gray-400 hover:text-indigo-400 transition-colors"
                      title="Bewerken">
                      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button
                      (click)="removeComponentFromCell(selectedGridCellIndex, j); $event.stopPropagation()"
                      class="p-1.5 text-gray-400 hover:text-red-400 transition-colors"
                      title="Verwijderen">
                      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Styling Options -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- (cell component modal removed - see end of file) -->

        <!-- Media Gallery Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'media-gallery'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Galerij Opties</h3>

            <!-- Layout Type -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Layout Type</label>
              <select
                [value]="getSelectedComponent()?.data?.['layoutType'] || 'grid'"
                (change)="updateTextComponentField('layoutType', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="grid">Grid</option>
                <option value="masonry">Masonry</option>
                <option value="carousel">Carousel</option>
                <option value="justified">Justified</option>
                <option value="hero">Hero Afbeelding</option>
                <option value="logo-ticker">Logo Ticker (scrollend)</option>
              </select>
            </div>

            <!-- Columns (for grid/masonry, not carousel/hero) -->
            <div *ngIf="getSelectedComponent()?.data?.['layoutType'] !== 'carousel' && getSelectedComponent()?.data?.['layoutType'] !== 'hero'" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aantal Kolommen</label>
              <select
                [value]="getSelectedComponent()?.data?.['columns'] || 3"
                (change)="updateTextComponentField('columns', +$any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option [value]="2">2 Kolommen</option>
                <option [value]="3">3 Kolommen</option>
                <option [value]="4">4 Kolommen</option>
                <option [value]="5">5 Kolommen</option>
                <option [value]="6">6 Kolommen</option>
              </select>
            </div>

            <!-- Gap -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Tussenruimte</label>
              <input
                type="number"
                [value]="getSelectedComponent()?.data?.['gap'] || 8"
                (input)="updateTextComponentField('gap', +$any($event.target).value)"
                min="0"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <!-- Image Height -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Hoogte</label>
              <div class="flex items-center space-x-2">
                <input
                  type="number"
                  [value]="getSelectedComponent()?.data?.['imageHeight'] || 200"
                  (input)="updateTextComponentField('imageHeight', +$any($event.target).value)"
                  min="1"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <select
                  [value]="getSelectedComponent()?.data?.['imageHeightUnit'] || 'px'"
                  (change)="updateTextComponentField('imageHeightUnit', $any($event.target).value)"
                  class="w-20 rounded-lg bg-gray-700 border-transparent px-2 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                  <option value="px">px</option>
                  <option value="vh">vh</option>
                </select>
              </div>
              <p class="mt-1 text-xs text-gray-500">Bijv. 400px of 75vh voor een hero</p>
            </div>

            <!-- Aspect Ratio -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aspect Ratio</label>
              <select
                [value]="getSelectedComponent()?.data?.['aspectRatio'] || 'auto'"
                (change)="updateTextComponentField('aspectRatio', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="auto">Auto (vaste hoogte)</option>
                <option value="1:1">1:1 (Vierkant)</option>
                <option value="4:3">4:3</option>
                <option value="16:9">16:9 (Widescreen)</option>
                <option value="3:2">3:2</option>
                <option value="2:3">2:3 (Portret)</option>
              </select>
            </div>

            <!-- Hover Effect -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Hover Effect</label>
              <select
                [value]="getSelectedComponent()?.data?.['hoverEffect'] || 'zoom'"
                (change)="updateTextComponentField('hoverEffect', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="none">Geen</option>
                <option value="zoom">Zoom</option>
                <option value="fade">Fade</option>
              </select>
            </div>

            <!-- Shadow -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Schaduw</label>
              <select
                [value]="getSelectedComponent()?.data?.['shadowStyle'] || 'sm'"
                (change)="updateTextComponentField('shadowStyle', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="none">Geen</option>
                <option value="sm">Klein</option>
                <option value="md">Medium</option>
                <option value="lg">Groot</option>
                <option value="xl">Extra Groot</option>
              </select>
            </div>

            <!-- Border Radius -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Border Radius</label>
              <input
                type="number"
                [value]="getSelectedComponent()?.data?.['imageBorderRadius'] || 8"
                (input)="updateTextComponentField('imageBorderRadius', +$any($event.target).value)"
                min="0"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <!-- Options -->
            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['enableLightbox'] !== false"
                  (change)="updateTextComponentField('enableLightbox', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Lightbox Inschakelen</span>
              </label>
            </div>

            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showCaptions'] !== false"
                  (change)="updateTextComponentField('showCaptions', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Bijschriften Tonen</span>
              </label>
            </div>

            <!-- Caption Position -->
            <div *ngIf="getSelectedComponent()?.data?.['showCaptions'] !== false" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Bijschrift Positie</label>
              <select
                [value]="getSelectedComponent()?.data?.['captionPosition'] || 'below'"
                (change)="updateTextComponentField('captionPosition', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="below">Onder afbeelding</option>
                <option value="overlay">Overlay (altijd zichtbaar)</option>
                <option value="hover">Overlay (bij hover)</option>
              </select>
            </div>

            <!-- Hero Options -->
            <div *ngIf="getSelectedComponent()?.data?.['layoutType'] === 'hero'" class="border-t border-gray-600 pt-4 mt-4">
              <h4 class="text-xs font-semibold text-gray-400 uppercase mb-3">Hero Opties</h4>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['fullWidth'] === true"
                    (change)="updateTextComponentField('fullWidth', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Volledige Breedte</span>
                </label>
                <p class="text-xs text-gray-500 mt-1 ml-6">De hero afbeelding neemt de volledige schermbreedte in</p>
              </div>
            </div>

            <!-- Logo Ticker Options -->
            <div *ngIf="getSelectedComponent()?.data?.['layoutType'] === 'logo-ticker'" class="border-t border-gray-600 pt-4 mt-4">
              <h4 class="text-xs font-semibold text-gray-400 uppercase mb-3">Ticker Opties</h4>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-300 mb-2">Snelheid</label>
                <input
                  type="range"
                  min="10"
                  max="100"
                  [value]="getSelectedComponent()?.data?.['tickerSpeed'] || 30"
                  (input)="updateTextComponentField('tickerSpeed', +$any($event.target).value)"
                  class="w-full accent-indigo-500">
                <div class="flex justify-between text-xs text-gray-500 mt-1">
                  <span>Langzaam</span>
                  <span>{{ getSelectedComponent()?.data?.['tickerSpeed'] || 30 }}</span>
                  <span>Snel</span>
                </div>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-300 mb-2">Logo Breedte (px)</label>
                <input
                  type="number"
                  min="60"
                  max="400"
                  [value]="getSelectedComponent()?.data?.['tickerImageWidth'] || 160"
                  (input)="updateTextComponentField('tickerImageWidth', +$any($event.target).value)"
                  class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-300 mb-2">Modus</label>
                <select
                  [value]="getSelectedComponent()?.data?.['tickerMode'] || 'continuous'"
                  (change)="updateTextComponentField('tickerMode', $any($event.target).value)"
                  class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                    hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                  <option value="continuous">Doorscrollend (continu)</option>
                  <option value="slide">Slidend (per set)</option>
                </select>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-300 mb-2">Padding (px)</label>
                <input
                  type="range"
                  min="0"
                  max="40"
                  [value]="getSelectedComponent()?.data?.['tickerPadding'] ?? 10"
                  (input)="updateTextComponentField('tickerPadding', +$any($event.target).value)"
                  class="w-full accent-indigo-500">
                <div class="flex justify-between text-xs text-gray-500 mt-1">
                  <span>0px</span>
                  <span>{{ getSelectedComponent()?.data?.['tickerPadding'] ?? 10 }}px</span>
                  <span>40px</span>
                </div>
              </div>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['tickerPauseOnHover'] !== false"
                    (change)="updateTextComponentField('tickerPauseOnHover', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Pauzeer bij hover</span>
                </label>
              </div>
            </div>

            <!-- Carousel Options -->
            <div *ngIf="getSelectedComponent()?.data?.['layoutType'] === 'carousel'" class="border-t border-gray-600 pt-4 mt-4">
              <h4 class="text-xs font-semibold text-gray-400 uppercase mb-3">Carousel Opties</h4>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['showNavigation'] !== false"
                    (change)="updateTextComponentField('showNavigation', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Navigatie Pijlen</span>
                </label>
              </div>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['showDots'] !== false"
                    (change)="updateTextComponentField('showDots', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Navigatie Dots</span>
                </label>
              </div>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['infiniteLoop'] !== false"
                    (change)="updateTextComponentField('infiniteLoop', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Oneindige Loop</span>
                </label>
              </div>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['fullWidth'] === true"
                    (change)="updateTextComponentField('fullWidth', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Volledige Breedte</span>
                </label>
                <p class="text-xs text-gray-500 mt-1 ml-6">De carousel neemt de volledige schermbreedte in</p>
              </div>
            </div>

            <!-- Add Images Button -->
            <div class="mb-4 mt-6">
              <label class="block text-sm font-medium text-gray-300 mb-2">Afbeeldingen</label>
              <button
                type="button"
                (click)="openMediaSelectorForGallery()"
                class="w-full inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-600">
                <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Afbeelding Toevoegen
              </button>
              <p class="mt-2 text-xs text-gray-400">
                {{ (getSelectedComponent()?.data?.['images'] || []).length }} afbeelding{{ (getSelectedComponent()?.data?.['images'] || []).length !== 1 ? 'en' : '' }} toegevoegd
              </p>
              
              <!-- Display Selected Images -->
              <div *ngIf="(getSelectedComponent()?.data?.['images'] || []).length > 0" class="mt-4 space-y-3 max-h-[50vh] overflow-y-auto pr-1">
                <div *ngFor="let image of getSelectedComponent()?.data?.['images']; let i = index; trackBy: trackByImageIndex" 
                     class="p-3 bg-gray-800 rounded-lg border border-gray-700">
                  <div class="flex items-start gap-3 mb-3">
                    <img [src]="image.url" 
                         [alt]="image.alt || 'Image'"
                         class="w-20 h-20 object-cover rounded flex-shrink-0">
                    <div class="flex-1 min-w-0">
                      <p class="text-xs text-gray-400 truncate mb-2">{{ image.url }}</p>
                      <input
                        type="text"
                        [value]="image.alt || ''"
                        (blur)="updateImageField(i, 'alt', $any($event.target).value)"
                        (keyup.enter)="blurInput($event)"
                        placeholder="Alt tekst"
                        class="w-full text-xs rounded bg-gray-700 border-transparent px-2 py-1 text-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                    </div>
                    <button
                      (click)="removeImageFromGallery(i)"
                      class="p-1 text-red-400 hover:text-red-300 transition-colors flex-shrink-0">
                      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <!-- Carousel / Hero Specific Fields -->
                  <div *ngIf="getSelectedComponent()?.data?.['layoutType'] === 'carousel' || getSelectedComponent()?.data?.['layoutType'] === 'hero'" class="mt-3 pt-3 border-t border-gray-700 space-y-3">
                    <!-- Subtitle (boven titel) -->
                    <div>
                      <label class="block text-xs font-medium text-gray-400 mb-1">Subtitel</label>
                      <input
                        type="text"
                        [value]="image.subtitle || ''"
                        (blur)="updateImageField(i, 'subtitle', $any($event.target).value)"
                        (keyup.enter)="blurInput($event)"
                        placeholder="Subtitel boven de titel"
                        class="w-full text-xs rounded bg-gray-700 border-transparent px-2 py-1.5 text-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                    </div>

                    <!-- Title -->
                    <div>
                      <label class="block text-xs font-medium text-gray-400 mb-1">Titel</label>
                      <input
                        type="text"
                        [value]="image.title || ''"
                        (blur)="updateImageField(i, 'title', $any($event.target).value)"
                        (keyup.enter)="blurInput($event)"
                        placeholder="Titel voor deze slide"
                        class="w-full text-xs rounded bg-gray-700 border-transparent px-2 py-1.5 text-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                    </div>

                    <!-- Description -->
                    <div>
                      <label class="block text-xs font-medium text-gray-400 mb-1">Omschrijving</label>
                      <textarea
                        [value]="image.description || ''"
                        (blur)="updateImageField(i, 'description', $any($event.target).value)"
                        placeholder="Omschrijving voor deze slide"
                        rows="2"
                        class="w-full text-xs rounded bg-gray-700 border-transparent px-2 py-1.5 text-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500 resize-none"></textarea>
                    </div>

                    <!-- CTA Buttons -->
                    <div>
                      <div class="flex items-center justify-between mb-2">
                        <label class="block text-xs font-medium text-gray-400">CTA Buttons</label>
                        <button
                          type="button"
                          (click)="addCTAToImage(i)"
                          class="text-xs px-2 py-1 bg-indigo-600 hover:bg-indigo-700 text-white rounded transition-colors">
                          + Button
                        </button>
                      </div>
                      <div *ngIf="(image.ctaButtons || []).length > 0" class="space-y-2">
                        <div *ngFor="let cta of image.ctaButtons; let j = index" 
                             class="p-2 bg-gray-900 rounded border border-gray-600">
                          <div class="flex items-start gap-2 mb-2">
                            <div class="flex-1 space-y-2">
                              <input
                                type="text"
                                [value]="cta.text || ''"
                                (blur)="updateCTAField(i, j, 'text', $any($event.target).value)"
                                (keyup.enter)="blurInput($event)"
                                placeholder="Button tekst"
                                class="w-full text-xs rounded bg-gray-700 border-transparent px-2 py-1 text-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                              <input
                                type="text"
                                [value]="cta.url || ''"
                                (blur)="updateCTAField(i, j, 'url', $any($event.target).value)"
                                (keyup.enter)="blurInput($event)"
                                placeholder="URL"
                                class="w-full text-xs rounded bg-gray-700 border-transparent px-2 py-1 text-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                              <select
                                [value]="cta.style || 'primary'"
                                (change)="updateCTAField(i, j, 'style', $any($event.target).value)"
                                class="w-full text-xs rounded bg-gray-700 border-transparent px-2 py-1 text-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                                <option value="primary">Primary</option>
                                <option value="secondary">Secondary</option>
                                <option value="outline">Outline</option>
                              </select>
                            </div>
                            <button
                              type="button"
                              (click)="removeCTAFromImage(i, j)"
                              class="p-1 text-red-400 hover:text-red-300 transition-colors flex-shrink-0">
                              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                      <p *ngIf="!(image.ctaButtons || []).length" class="text-xs text-gray-500 italic">
                        Geen buttons toegevoegd
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Styling Options -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- News Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'news'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Nieuws Opties</h3>

            <!-- Layout Type -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Layout Type</label>
              <select
                [value]="getSelectedComponent()?.data?.['layoutType'] || 'cards'"
                (change)="updateTextComponentField('layoutType', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="cards">Kaarten</option>
                <option value="grid">Grid</option>
                <option value="list">Lijst</option>
                <option value="compact">Compact</option>
                <option value="featured">Featured (1 groot + rest klein)</option>
              </select>
            </div>

            <!-- Category Filter -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Categorie Filter</label>
              <div *ngIf="categories.length === 0" class="text-sm text-gray-400 italic py-2">
                Geen categorieën gevonden. Maak eerst categorieën aan in de Posts module.
              </div>
              <div *ngIf="categories.length > 0" class="space-y-2 max-h-48 overflow-y-auto bg-gray-700 rounded-lg p-3">
                <div class="text-xs text-gray-400 mb-2">Selecteer categorieën om te tonen (leeg = alle)</div>
                <label *ngFor="let category of categories" class="flex items-center space-x-2 cursor-pointer py-1 hover:bg-gray-600 px-2 rounded">
                  <input
                    type="checkbox"
                    [checked]="(getSelectedComponent()?.data?.['selectedCategoryIds'] || []).includes(category.id)"
                    (change)="toggleNewsCategoryFilter(category.id)"
                    class="w-4 h-4 rounded bg-gray-600 border-gray-500 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm text-gray-200">{{ category.name }}</span>
                </label>
              </div>
              <div *ngIf="(getSelectedComponent()?.data?.['selectedCategoryIds'] || []).length > 0" class="mt-2 text-xs text-indigo-400">
                {{ (getSelectedComponent()?.data?.['selectedCategoryIds'] || []).length }} categorie(ën) geselecteerd
              </div>
            </div>

            <!-- Columns -->
            <div *ngIf="getSelectedComponent()?.data?.['layoutType'] !== 'list' && getSelectedComponent()?.data?.['layoutType'] !== 'compact'" class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aantal Kolommen</label>
              <select
                [value]="getSelectedComponent()?.data?.['columns'] || 3"
                (change)="updateTextComponentField('columns', +$any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option [value]="2">2 Kolommen</option>
                <option [value]="3">3 Kolommen</option>
                <option [value]="4">4 Kolommen</option>
              </select>
            </div>

            <!-- Limit -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aantal Berichten</label>
              <input
                type="number"
                [value]="getSelectedComponent()?.data?.['limit'] || 6"
                (input)="updateTextComponentField('limit', +$any($event.target).value)"
                min="1"
                max="50"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <!-- Card Style -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Kaart Stijl</label>
              <select
                [value]="getSelectedComponent()?.data?.['cardStyle'] || 'elevated'"
                (change)="updateTextComponentField('cardStyle', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="elevated">Met Schaduw</option>
                <option value="bordered">Met Border</option>
                <option value="flat">Plat</option>
              </select>
            </div>

            <!-- Date Format -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Datum Formaat</label>
              <select
                [value]="getSelectedComponent()?.data?.['dateFormat'] || 'medium'"
                (change)="updateTextComponentField('dateFormat', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="short">Kort (01/01/24)</option>
                <option value="medium">Medium (1 jan 2024)</option>
                <option value="long">Lang (1 januari 2024)</option>
                <option value="relative">Relatief (2 dagen geleden)</option>
              </select>
            </div>

            <!-- Excerpt Length -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Excerpt Lengte</label>
              <input
                type="number"
                [value]="getSelectedComponent()?.data?.['excerptLength'] || 150"
                (input)="updateTextComponentField('excerptLength', +$any($event.target).value)"
                min="50"
                max="500"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
              <p class="mt-1 text-xs text-gray-400">Aantal karakters voor excerpt</p>
            </div>

            <!-- Read More Text -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Lees Meer Tekst</label>
              <input
                type="text"
                [value]="getSelectedComponent()?.data?.['readMoreText'] || 'Lees meer'"
                (input)="updateTextComponentField('readMoreText', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
            </div>

            <!-- Display Options -->
            <div class="border-t border-gray-600 pt-4 mt-4">
              <h4 class="text-xs font-semibold text-gray-400 uppercase mb-3">Weergave Opties</h4>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['showImage'] !== false"
                    (change)="updateTextComponentField('showImage', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Afbeelding Tonen</span>
                </label>
              </div>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['showDate'] !== false"
                    (change)="updateTextComponentField('showDate', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Datum Tonen</span>
                </label>
              </div>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['showExcerpt'] !== false"
                    (change)="updateTextComponentField('showExcerpt', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Excerpt Tonen</span>
                </label>
              </div>

              <div class="mb-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="getSelectedComponent()?.data?.['showReadMore'] !== false"
                    (change)="updateTextComponentField('showReadMore', $any($event.target).checked)"
                    class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                  <span class="text-sm font-medium text-gray-300">Lees Meer Link</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Styling Options -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- Projects Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'projects'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Projecten Opties</h3>

            <!-- Sortering -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Sortering</label>
              <select
                [value]="getSelectedComponent()?.data?.['sortBy'] || 'title-asc'"
                (change)="updateTextComponentField('sortBy', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="title-asc">Titel A-Z</option>
                <option value="title-desc">Titel Z-A</option>
                <option value="newest">Nieuwste eerst</option>
                <option value="oldest">Oudste eerst</option>
                <option value="manual">Handmatige volgorde (geselecteerde projecten)</option>
                <option value="random">Willekeurig</option>
              </select>
              <p *ngIf="getSelectedComponent()?.data?.['sortBy'] === 'manual' && !(getSelectedComponent()?.data?.['selectedProjectIds'] || []).length"
                 class="mt-1 text-[11px] text-amber-400">
                Handmatige volgorde werkt alleen met geselecteerde projecten. Selecteer projecten hieronder.
              </p>
            </div>

            <!-- View Type -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Weergave Type</label>
              <select
                [value]="getSelectedComponent()?.data?.['viewType'] || 'grid'"
                (change)="updateTextComponentField('viewType', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option value="grid">Grid</option>
                <option value="list">Lijst</option>
                <option value="cards">Kaarten</option>
              </select>
            </div>

            <!-- Columns -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Aantal Kolommen</label>
              <select
                [value]="getSelectedComponent()?.data?.['columns'] || 3"
                (change)="updateTextComponentField('columns', +$any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200 
                  hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
                <option [value]="1">1 Kolom</option>
                <option [value]="2">2 Kolommen</option>
                <option [value]="3">3 Kolommen</option>
                <option [value]="4">4 Kolommen</option>
              </select>
            </div>

            <!-- Display Options -->
            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showDescription'] !== false"
                  (change)="updateTextComponentField('showDescription', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Beschrijving Tonen</span>
              </label>
            </div>

            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showCategory'] !== false"
                  (change)="updateTextComponentField('showCategory', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Categorie Tonen</span>
              </label>
            </div>

            <div class="mb-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showCategoryTabs'] === true"
                  (change)="updateTextComponentField('showCategoryTabs', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
                <span class="text-sm font-medium text-gray-300">Categorie Tabs (filter op hoofdcategorie)</span>
              </label>
            </div>

            <!-- Project Selection -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Geselecteerde Projecten</label>
              <button
                type="button"
                (click)="openProjectSelector()"
                class="w-full inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-600">
                <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Selecteer Projecten
              </button>
              <p *ngIf="(getSelectedComponent()?.data?.['selectedProjectIds'] || []).length > 0" class="mt-2 text-xs text-gray-400">
                {{ (getSelectedComponent()?.data?.['selectedProjectIds'] || []).length }} project{{ (getSelectedComponent()?.data?.['selectedProjectIds'] || []).length !== 1 ? 'en' : '' }} geselecteerd
              </p>
              <p *ngIf="!(getSelectedComponent()?.data?.['selectedProjectIds'] || []).length" class="mt-2 text-xs text-gray-400">
                Geen projecten geselecteerd
              </p>
            </div>
          </div>

          <!-- Styling Options -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- Form Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'form'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Formulier Opties</h3>

            <!-- Heading -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Titel</label>
              <input type="text"
                [value]="getSelectedComponent()?.data?.['heading'] || ''"
                (input)="updateTextComponentField('heading', $any($event.target).value)"
                placeholder="Formulier titel"
                class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>

            <!-- Description -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Beschrijving</label>
              <textarea
                [value]="getSelectedComponent()?.data?.['description'] || ''"
                (input)="updateTextComponentField('description', $any($event.target).value)"
                placeholder="Optionele beschrijving boven het formulier"
                rows="2"
                class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none"></textarea>
            </div>

            <!-- Submit Button Text -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Knop tekst</label>
              <input type="text"
                [value]="getSelectedComponent()?.data?.['submitButtonText'] || 'Versturen'"
                (input)="updateTextComponentField('submitButtonText', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>

            <!-- Success Message -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Succesmelding</label>
              <input type="text"
                [value]="getSelectedComponent()?.data?.['successMessage'] || ''"
                (input)="updateTextComponentField('successMessage', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>

            <!-- Notification Email -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Notificatie e-mail</label>
              <input type="email"
                [value]="getSelectedComponent()?.data?.['notificationEmail'] || ''"
                (input)="updateTextComponentField('notificationEmail', $any($event.target).value)"
                placeholder="optioneel@email.com"
                class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>
          </div>

          <!-- Form Fields Management -->
          <div class="border-t border-gray-700 pt-4">
            <h3 class="text-sm font-semibold text-gray-200 mb-3">Formulier Velden</h3>

            <div class="space-y-3">
              <div *ngFor="let field of getSelectedComponent()?.data?.['fields'] || []; let fi = index"
                class="bg-gray-900 rounded-lg p-3 border border-gray-700">

                <!-- Field Header -->
                <div class="flex items-center justify-between mb-2">
                  <span class="text-xs text-gray-400 font-mono">{{ field.type }}</span>
                  <div class="flex items-center gap-1">
                    <button (click)="moveFormFieldUp(fi)" [disabled]="fi === 0"
                      class="p-1 text-gray-400 hover:text-gray-200 disabled:opacity-30" title="Omhoog">
                      <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"/></svg>
                    </button>
                    <button (click)="moveFormFieldDown(fi)" [disabled]="fi === (getSelectedComponent()?.data?.['fields']?.length || 0) - 1"
                      class="p-1 text-gray-400 hover:text-gray-200 disabled:opacity-30" title="Omlaag">
                      <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/></svg>
                    </button>
                    <button (click)="removeFormField(fi)"
                      class="p-1 text-red-400 hover:text-red-300" title="Verwijderen">
                      <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
                    </button>
                  </div>
                </div>

                <!-- Label -->
                <div class="mb-2">
                  <input type="text"
                    [value]="field.label"
                    (input)="updateFormField(fi, 'label', $any($event.target).value)"
                    placeholder="Label"
                    class="w-full rounded bg-gray-800 border-gray-600 text-gray-200 text-sm px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500">
                </div>

                <!-- Type + Required + Width row -->
                <div class="flex items-center gap-2 mb-2">
                  <select
                    [value]="field.type"
                    (change)="updateFormField(fi, 'type', $any($event.target).value)"
                    class="flex-1 rounded bg-gray-800 border-gray-600 text-gray-200 text-xs px-2 py-1.5">
                    <option value="text">Tekst</option>
                    <option value="email">E-mail</option>
                    <option value="tel">Telefoon</option>
                    <option value="textarea">Tekstvak</option>
                    <option value="select">Dropdown</option>
                    <option value="checkbox">Checkbox</option>
                  </select>

                  <label class="flex items-center gap-1 text-xs text-gray-300 cursor-pointer whitespace-nowrap">
                    <input type="checkbox"
                      [checked]="field.required"
                      (change)="updateFormField(fi, 'required', $any($event.target).checked)"
                      class="w-3.5 h-3.5 rounded accent-indigo-500">
                    Verplicht
                  </label>

                  <select
                    [value]="field.width || 'full'"
                    (change)="updateFormField(fi, 'width', $any($event.target).value)"
                    class="rounded bg-gray-800 border-gray-600 text-gray-200 text-xs px-2 py-1.5">
                    <option value="full">Vol</option>
                    <option value="half">Half</option>
                  </select>
                </div>

                <!-- Placeholder -->
                <div *ngIf="field.type !== 'checkbox'" class="mb-2">
                  <input type="text"
                    [value]="field.placeholder || ''"
                    (input)="updateFormField(fi, 'placeholder', $any($event.target).value)"
                    placeholder="Placeholder tekst"
                    class="w-full rounded bg-gray-800 border-gray-600 text-gray-300 text-xs px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500">
                </div>

                <!-- Select Options -->
                <div *ngIf="field.type === 'select'" class="mt-2">
                  <label class="block text-xs text-gray-400 mb-1">Opties</label>
                  <div *ngFor="let opt of field.options || []; let oi = index" class="flex items-center gap-1 mb-1">
                    <input type="text"
                      [value]="opt"
                      (input)="updateSelectOption(fi, oi, $any($event.target).value)"
                      placeholder="Optie"
                      class="flex-1 rounded bg-gray-800 border-gray-600 text-gray-300 text-xs px-2 py-1">
                    <button (click)="removeSelectOption(fi, oi)" class="p-0.5 text-red-400 hover:text-red-300">
                      <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
                    </button>
                  </div>
                  <button (click)="addSelectOption(fi)"
                    class="text-xs text-indigo-400 hover:text-indigo-300 mt-1">
                    + Optie toevoegen
                  </button>
                </div>
              </div>
            </div>

            <!-- Add Field Button -->
            <button (click)="addFormField()"
              class="mt-3 w-full py-2 rounded-lg border border-dashed border-gray-600 text-sm text-gray-400 hover:text-gray-200 hover:border-gray-400 transition-colors">
              + Veld toevoegen
            </button>
          </div>

          <!-- Styling Options -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- Map Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'map'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Kaart Opties</h3>

            <!-- Heading -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Titel</label>
              <input type="text"
                [value]="getSelectedComponent()?.data?.['heading'] || ''"
                (input)="updateTextComponentField('heading', $any($event.target).value)"
                placeholder="Kaart titel"
                class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>

            <!-- Subtitle -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel</label>
              <input type="text"
                [value]="getSelectedComponent()?.data?.['subtitle'] || ''"
                (input)="updateTextComponentField('subtitle', $any($event.target).value)"
                placeholder="Subtitel"
                class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>

            <!-- Address Search -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Adres zoeken</label>
              <div class="flex gap-2">
                <input type="text"
                  [(ngModel)]="mapAddressQuery"
                  (keydown.enter)="geocodeMapAddress()"
                  placeholder="Bijv. Damrak 1, Amsterdam"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
                <button
                  (click)="geocodeMapAddress()"
                  [disabled]="mapAddressLoading"
                  class="px-3 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 text-white text-sm transition-colors flex-shrink-0">
                  <svg *ngIf="!mapAddressLoading" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                  </svg>
                  <svg *ngIf="mapAddressLoading" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                  </svg>
                </button>
              </div>
              <p class="text-xs text-gray-500 mt-1">Centreert de kaart en plaatst een marker</p>
            </div>

            <!-- Lat / Lng -->
            <div class="flex gap-3 mb-4">
              <div class="flex-1">
                <label class="block text-sm font-medium text-gray-300 mb-2">Latitude</label>
                <input type="number" step="0.0001"
                  [value]="getSelectedComponent()?.data?.['lat'] || 52.3676"
                  (input)="updateTextComponentField('lat', +$any($event.target).value)"
                  class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
              <div class="flex-1">
                <label class="block text-sm font-medium text-gray-300 mb-2">Longitude</label>
                <input type="number" step="0.0001"
                  [value]="getSelectedComponent()?.data?.['lng'] || 4.9041"
                  (input)="updateTextComponentField('lng', +$any($event.target).value)"
                  class="w-full rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
            </div>

            <!-- Zoom -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Zoom (1-19)</label>
              <input type="range" min="1" max="19" step="1"
                [value]="getSelectedComponent()?.data?.['zoom'] || 13"
                (input)="updateTextComponentField('zoom', +$any($event.target).value)"
                class="w-full accent-indigo-500">
              <div class="flex justify-between text-xs text-gray-500 mt-1">
                <span>Wereld</span>
                <span class="text-gray-300">{{ getSelectedComponent()?.data?.['zoom'] || 13 }}</span>
                <span>Straat</span>
              </div>
            </div>

            <!-- Map Height -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Kaart hoogte</label>
              <div class="flex gap-2">
                <input type="number" min="100" max="1000"
                  [value]="getSelectedComponent()?.data?.['mapHeight'] || 400"
                  (input)="updateTextComponentField('mapHeight', +$any($event.target).value)"
                  class="flex-1 rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
                <select
                  [value]="getSelectedComponent()?.data?.['mapHeightUnit'] || 'px'"
                  (change)="updateTextComponentField('mapHeightUnit', $any($event.target).value)"
                  class="w-20 rounded-lg bg-gray-700 border-transparent text-gray-200 text-sm px-2 py-2 focus:ring-indigo-500 focus:border-indigo-500">
                  <option value="px">px</option>
                  <option value="vh">vh</option>
                </select>
              </div>
            </div>

            <!-- Border Radius -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-300 mb-2">Hoekafronding</label>
              <input type="range" min="0" max="32" step="1"
                [value]="getSelectedComponent()?.data?.['borderRadius'] ?? 8"
                (input)="updateTextComponentField('borderRadius', +$any($event.target).value)"
                class="w-full accent-indigo-500">
              <div class="text-xs text-gray-400 mt-1">{{ getSelectedComponent()?.data?.['borderRadius'] ?? 8 }}px</div>
            </div>

            <!-- Toggles -->
            <div class="space-y-3 mb-4">
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['showZoomControl'] !== false"
                  (change)="updateTextComponentField('showZoomControl', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 accent-indigo-500">
                <span class="text-sm text-gray-300">Zoom knoppen tonen</span>
              </label>
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['scrollWheelZoom'] || false"
                  (change)="updateTextComponentField('scrollWheelZoom', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 accent-indigo-500">
                <span class="text-sm text-gray-300">Scrollwiel zoom</span>
              </label>
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['fullWidth'] || false"
                  (change)="updateTextComponentField('fullWidth', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 accent-indigo-500">
                <span class="text-sm text-gray-300">Paginabreed</span>
              </label>
            </div>
          </div>

          <!-- Markers -->
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-3">Markers</h3>

            <div *ngIf="(getSelectedComponent()?.data?.['markers'] || []).length === 0"
              class="text-center py-4 text-gray-500 text-xs">
              Geen markers. Standaard wordt de center positie gemarkeerd.
            </div>

            <div *ngFor="let marker of getSelectedComponent()?.data?.['markers'] || []; let mi = index"
              class="mb-3 p-3 bg-gray-750 rounded-lg border border-gray-600 space-y-2"
              style="background-color: rgba(55,65,81,0.5);">

              <div class="flex items-center justify-between">
                <span class="text-xs font-medium text-gray-400">Marker {{ mi + 1 }}</span>
                <button (click)="removeMapMarker(mi)" class="p-1 text-red-400 hover:text-red-300 transition-colors">
                  <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
                </button>
              </div>

              <!-- Marker Address Search -->
              <div class="flex gap-1">
                <input type="text"
                  [(ngModel)]="markerAddressQueries[mi]"
                  (keydown.enter)="geocodeMarkerAddress(mi)"
                  placeholder="Adres zoeken..."
                  class="flex-1 rounded bg-gray-800 border-gray-600 text-gray-300 text-xs px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500">
                <button
                  (click)="geocodeMarkerAddress(mi)"
                  [disabled]="markerAddressLoading[mi]"
                  class="px-2 py-1.5 rounded bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 text-white transition-colors flex-shrink-0">
                  <svg *ngIf="!markerAddressLoading[mi]" class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                  </svg>
                  <svg *ngIf="markerAddressLoading[mi]" class="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                  </svg>
                </button>
              </div>

              <!-- Marker Title -->
              <input type="text"
                [value]="marker.title || ''"
                (input)="updateMapMarker(mi, 'title', $any($event.target).value)"
                placeholder="Titel"
                class="w-full rounded bg-gray-800 border-gray-600 text-gray-300 text-xs px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500">

              <!-- Marker Description -->
              <input type="text"
                [value]="marker.description || ''"
                (input)="updateMapMarker(mi, 'description', $any($event.target).value)"
                placeholder="Beschrijving"
                class="w-full rounded bg-gray-800 border-gray-600 text-gray-300 text-xs px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500">

              <!-- Marker Lat/Lng -->
              <div class="flex gap-2">
                <input type="number" step="0.0001"
                  [value]="marker.lat"
                  (input)="updateMapMarker(mi, 'lat', $any($event.target).value)"
                  placeholder="Lat"
                  class="flex-1 rounded bg-gray-800 border-gray-600 text-gray-300 text-xs px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500">
                <input type="number" step="0.0001"
                  [value]="marker.lng"
                  (input)="updateMapMarker(mi, 'lng', $any($event.target).value)"
                  placeholder="Lng"
                  class="flex-1 rounded bg-gray-800 border-gray-600 text-gray-300 text-xs px-2 py-1.5 focus:ring-indigo-500 focus:border-indigo-500">
              </div>

              <!-- Popup open by default -->
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="checkbox"
                  [checked]="marker.popupOpen || false"
                  (change)="updateMapMarker(mi, 'popupOpen', $any($event.target).checked)"
                  class="w-3.5 h-3.5 rounded bg-gray-800 border-gray-600 accent-indigo-500">
                <span class="text-xs text-gray-400">Tooltip standaard open</span>
              </label>
            </div>

            <!-- Add Marker Button -->
            <button (click)="addMapMarker()"
              class="mt-2 w-full py-2 rounded-lg border border-dashed border-gray-600 text-sm text-gray-400 hover:text-gray-200 hover:border-gray-400 transition-colors">
              + Marker toevoegen
            </button>
          </div>

          <!-- Styling Options -->
          <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
        </div>

        <!-- Action Component Options -->
        <div *ngIf="getSelectedComponent()?.type === 'action'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-4">Action Element</h3>

            <!-- Variant keuze -->
            <div class="mb-4">
              <label class="block text-xs font-medium text-gray-400 mb-2">Type</label>
              <div class="grid grid-cols-3 gap-2">
                <button
                  (click)="updateTextComponentField('variant', 'button')"
                  class="px-3 py-2 rounded-lg text-xs font-medium transition-colors"
                  [ngClass]="getSelectedComponent()?.data?.['variant'] === 'button' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  Button
                </button>
                <button
                  (click)="updateTextComponentField('variant', 'banner')"
                  class="px-3 py-2 rounded-lg text-xs font-medium transition-colors"
                  [ngClass]="getSelectedComponent()?.data?.['variant'] === 'banner' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  Banner
                </button>
                <button
                  (click)="updateTextComponentField('variant', 'cta')"
                  class="px-3 py-2 rounded-lg text-xs font-medium transition-colors"
                  [ngClass]="getSelectedComponent()?.data?.['variant'] === 'cta' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  CTA
                </button>
              </div>
            </div>

            <!-- Primaire button tekst + link (altijd zichtbaar) -->
            <div class="mb-4">
              <label class="block text-xs font-medium text-gray-400 mb-1">Button tekst</label>
              <input type="text"
                [value]="getSelectedComponent()?.data?.['text'] || ''"
                (input)="updateTextComponentField('text', $any($event.target).value)"
                placeholder="Klik hier"
                class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>

            <div class="mb-4">
              <label class="block text-xs font-medium text-gray-400 mb-1">Link URL</label>
              <input type="text"
                [value]="getSelectedComponent()?.data?.['link'] || ''"
                (input)="updateTextComponentField('link', $any($event.target).value)"
                placeholder="/contact of https://..."
                class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
            </div>

            <label class="flex items-center gap-2 cursor-pointer mb-4">
              <input type="checkbox"
                [checked]="getSelectedComponent()?.data?.['openInNewTab'] || false"
                (change)="updateTextComponentField('openInNewTab', $any($event.target).checked)"
                class="w-4 h-4 rounded bg-gray-700 border-gray-600 accent-indigo-500">
              <span class="text-xs text-gray-400">Open in nieuw tabblad</span>
            </label>

            <!-- Button stijl -->
            <div class="mb-4">
              <label class="block text-xs font-medium text-gray-400 mb-1">Button stijl</label>
              <select
                [value]="getSelectedComponent()?.data?.['buttonStyle'] || 'primary'"
                (change)="updateTextComponentField('buttonStyle', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
                <option value="primary">Primair (gevuld)</option>
                <option value="secondary">Secundair</option>
                <option value="outline">Outline</option>
              </select>
            </div>

            <!-- Button grootte -->
            <div class="mb-4">
              <label class="block text-xs font-medium text-gray-400 mb-1">Grootte</label>
              <select
                [value]="getSelectedComponent()?.data?.['buttonSize'] || 'md'"
                (change)="updateTextComponentField('buttonSize', $any($event.target).value)"
                class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
                <option value="sm">Klein</option>
                <option value="md">Medium</option>
                <option value="lg">Groot</option>
              </select>
            </div>

            <!-- Uitlijning -->
            <div class="mb-4">
              <label class="block text-xs font-medium text-gray-400 mb-2">Uitlijning</label>
              <div class="grid grid-cols-3 gap-2">
                <button
                  (click)="updateTextComponentField('alignment', 'left')"
                  class="px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
                  [ngClass]="getSelectedComponent()?.data?.['alignment'] === 'left' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  Links
                </button>
                <button
                  (click)="updateTextComponentField('alignment', 'center')"
                  class="px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
                  [ngClass]="(getSelectedComponent()?.data?.['alignment'] || 'center') === 'center' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  Midden
                </button>
                <button
                  (click)="updateTextComponentField('alignment', 'right')"
                  class="px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
                  [ngClass]="getSelectedComponent()?.data?.['alignment'] === 'right' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  Rechts
                </button>
              </div>
            </div>

            <!-- Secundaire button (CTA en Banner) -->
            <div *ngIf="getSelectedComponent()?.data?.['variant'] !== 'button'" class="border-t border-gray-700 pt-4 mt-4">
              <h4 class="text-xs font-semibold text-gray-300 mb-3">Secundaire button</h4>
              <div class="mb-3">
                <label class="block text-xs font-medium text-gray-400 mb-1">Tekst</label>
                <input type="text"
                  [value]="getSelectedComponent()?.data?.['secondaryText'] || ''"
                  (input)="updateTextComponentField('secondaryText', $any($event.target).value)"
                  placeholder="Meer info"
                  class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
              <div class="mb-3">
                <label class="block text-xs font-medium text-gray-400 mb-1">Link URL</label>
                <input type="text"
                  [value]="getSelectedComponent()?.data?.['secondaryLink'] || ''"
                  (input)="updateTextComponentField('secondaryLink', $any($event.target).value)"
                  placeholder="/over-ons"
                  class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="checkbox"
                  [checked]="getSelectedComponent()?.data?.['secondaryOpenInNewTab'] || false"
                  (change)="updateTextComponentField('secondaryOpenInNewTab', $any($event.target).checked)"
                  class="w-4 h-4 rounded bg-gray-700 border-gray-600 accent-indigo-500">
                <span class="text-xs text-gray-400">Open in nieuw tabblad</span>
              </label>
            </div>

            <!-- Banner-specifieke opties -->
            <div *ngIf="getSelectedComponent()?.data?.['variant'] === 'banner'" class="border-t border-gray-700 pt-4 mt-4">
              <h4 class="text-xs font-semibold text-gray-300 mb-3">Banner opties</h4>
              <div class="mb-3">
                <label class="block text-xs font-medium text-gray-400 mb-1">Banner titel</label>
                <input type="text"
                  [value]="getSelectedComponent()?.data?.['bannerTitle'] || ''"
                  (input)="updateTextComponentField('bannerTitle', $any($event.target).value)"
                  placeholder="Neem contact op"
                  class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
              <div class="mb-3">
                <label class="block text-xs font-medium text-gray-400 mb-1">Banner subtitel</label>
                <input type="text"
                  [value]="getSelectedComponent()?.data?.['bannerSubtitle'] || ''"
                  (input)="updateTextComponentField('bannerSubtitle', $any($event.target).value)"
                  placeholder="Wij helpen u graag verder"
                  class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
              <div class="grid grid-cols-2 gap-3 mb-3">
                <div>
                  <label class="block text-xs font-medium text-gray-400 mb-1">Achtergrondkleur</label>
                  <input type="color"
                    [value]="getSelectedComponent()?.data?.['bannerBackgroundColor'] || '#007bff'"
                    (input)="updateTextComponentField('bannerBackgroundColor', $any($event.target).value)"
                    class="w-full h-8 rounded bg-gray-700 border-gray-600 cursor-pointer">
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-400 mb-1">Tekstkleur</label>
                  <input type="color"
                    [value]="getSelectedComponent()?.data?.['bannerTextColor'] || '#ffffff'"
                    (input)="updateTextComponentField('bannerTextColor', $any($event.target).value)"
                    class="w-full h-8 rounded bg-gray-700 border-gray-600 cursor-pointer">
                </div>
              </div>
            </div>

            <!-- CTA-specifieke opties -->
            <div *ngIf="getSelectedComponent()?.data?.['variant'] === 'cta'" class="border-t border-gray-700 pt-4 mt-4">
              <h4 class="text-xs font-semibold text-gray-300 mb-3">CTA opties</h4>
              <div class="mb-3">
                <label class="block text-xs font-medium text-gray-400 mb-1">CTA titel</label>
                <input type="text"
                  [value]="getSelectedComponent()?.data?.['bannerTitle'] || ''"
                  (input)="updateTextComponentField('bannerTitle', $any($event.target).value)"
                  placeholder="Klaar om te beginnen?"
                  class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
              <div class="mb-3">
                <label class="block text-xs font-medium text-gray-400 mb-1">CTA subtitel</label>
                <input type="text"
                  [value]="getSelectedComponent()?.data?.['bannerSubtitle'] || ''"
                  (input)="updateTextComponentField('bannerSubtitle', $any($event.target).value)"
                  placeholder="Neem vandaag nog contact met ons op"
                  class="w-full rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500">
              </div>
              <div class="grid grid-cols-2 gap-3 mb-3">
                <div>
                  <label class="block text-xs font-medium text-gray-400 mb-1">Achtergrondkleur</label>
                  <input type="color"
                    [value]="getSelectedComponent()?.data?.['bannerBackgroundColor'] || '#007bff'"
                    (input)="updateTextComponentField('bannerBackgroundColor', $any($event.target).value)"
                    class="w-full h-8 rounded bg-gray-700 border-gray-600 cursor-pointer">
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-400 mb-1">Tekstkleur</label>
                  <input type="color"
                    [value]="getSelectedComponent()?.data?.['bannerTextColor'] || '#ffffff'"
                    (input)="updateTextComponentField('bannerTextColor', $any($event.target).value)"
                    class="w-full h-8 rounded bg-gray-700 border-gray-600 cursor-pointer">
                </div>
              </div>
            </div>

            <!-- Padding -->
            <div class="border-t border-gray-700 pt-4 mt-4">
              <label class="block text-xs font-medium text-gray-400 mb-1">Verticale padding (px)</label>
              <input type="range" min="0" max="120" step="8"
                [value]="getSelectedComponent()?.data?.['paddingY'] || 48"
                (input)="updateTextComponentField('paddingY', +$any($event.target).value)"
                class="w-full accent-indigo-500">
              <span class="text-xs text-gray-500">{{ getSelectedComponent()?.data?.['paddingY'] || 48 }}px</span>
            </div>

            <!-- Styling Options -->
            <ng-container *ngTemplateOutlet="sectionStylingTemplate"></ng-container>
          </div>
        </div>

        <!-- HTML Block Options -->
        <div *ngIf="getSelectedComponent()?.type === 'html-block'" class="space-y-6 border-t border-gray-700 pt-6">
          <div>
            <h3 class="text-sm font-semibold text-gray-200 mb-2">HTML / CSS / JavaScript</h3>
            <p class="text-xs text-gray-400 mb-3 leading-relaxed">
              Plak hier je HTML in. <code class="text-indigo-300">&lt;style&gt;</code> en <code class="text-indigo-300">&lt;script&gt;</code> blokken worden op de live-site uitgevoerd. In deze editor zie je de preview in een geïsoleerd iframe.
            </p>
            <textarea
              [ngModel]="getSelectedComponent()?.data?.['html'] || ''"
              (ngModelChange)="updateTextComponentField('html', $event)"
              rows="18"
              spellcheck="false"
              autocorrect="off"
              autocapitalize="off"
              class="w-full font-mono text-xs bg-gray-900 border border-gray-700 rounded-md px-3 py-2 text-gray-100 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              placeholder="&lt;div&gt;...&lt;/div&gt;&#10;&lt;style&gt;...&lt;/style&gt;&#10;&lt;script&gt;...&lt;/script&gt;">
            </textarea>
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-400 mb-2">Wrapper CSS-class (optioneel)</label>
            <input
              type="text"
              [ngModel]="getSelectedComponent()?.data?.['wrapperClass'] || ''"
              (ngModelChange)="updateTextComponentField('wrapperClass', $event)"
              class="w-full bg-gray-900 border border-gray-700 rounded-md px-3 py-2 text-sm text-gray-100 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              placeholder="bv. max-w-3xl mx-auto" />
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-400 mb-2">
              Verticale padding: {{ getSelectedComponent()?.data?.['paddingY'] || 0 }}px
            </label>
            <input
              type="range"
              min="0"
              max="120"
              step="4"
              [ngModel]="getSelectedComponent()?.data?.['paddingY'] || 0"
              (ngModelChange)="updateTextComponentField('paddingY', +$event)"
              class="w-full accent-indigo-500" />
          </div>
        </div>

      <div class="p-4 border-t border-gray-700">
        <button
          *ngIf="selectedComponentIndex !== null"
          (click)="removeComponent(selectedComponentIndex)"
          class="w-full inline-flex items-center justify-center rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-red-600">
          <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Component Verwijderen
        </button>
      </div>
    </div>
  </div>

  <!-- Empty State (when no page loaded) -->
  <div *ngIf="!currentPage" class="flex items-center justify-center h-[calc(100vh-64px)]">
    <div class="text-center py-12 bg-gray-800 rounded-lg border border-gray-700 px-8">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
      </svg>
      <h3 class="mt-2 text-sm font-medium text-gray-200">Pagina niet gevonden</h3>
      <p class="mt-1 text-sm text-gray-400">De pagina die je zoekt bestaat niet of is verplaatst.</p>
      <button (click)="closeEditor()" class="mt-4 inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500">
        Terug naar Pagina's
      </button>
    </div>
  </div>

  <app-notification></app-notification>

  <!-- Onboarding tour: eenmalig per gebruiker, herstartbaar via het "?"-knopje -->
  <app-onboarding-tour
    *ngIf="currentPage"
    storageKey="cockpit-onboarding-page-editor"
    [version]="1"
    reopenLabel="Rondleiding herstarten"
    [steps]="onboardingSteps">
  </app-onboarding-tour>

  <!-- Delete Confirmation Modal -->
  <app-confirm-modal
    [show]="showDeleteConfirmModal"
    title="Component Verwijderen"
    message="Weet je zeker dat je dit component wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt."
    (onConfirm)="confirmDeleteComponent()"
    (onCancel)="cancelDeleteComponent()">
  </app-confirm-modal>


  <!-- Media Selector Modal -->
  <app-media-selector-modal
    [show]="showMediaSelectorModal"
    (onSelect)="onMediaSelected($event)"
    (onClose)="closeMediaSelector()">
  </app-media-selector-modal>

  <!-- Product Selector Modal -->
  <app-product-selector-modal
    [show]="showProductSelectorModal"
    [selectedProductIds]="getSelectedComponent()?.data?.['selectedProductIds'] || []"
    [currentLocale]="currentLocale"
    (onSelect)="onProductsSelected($event)"
    (onClose)="closeProductSelector()">
  </app-product-selector-modal>

  <!-- Project Selector Modal -->
  <app-project-selector-modal
    [show]="showProjectSelectorModal"
    [selectedProjectIds]="getSelectedComponent()?.data?.['selectedProjectIds'] || []"
    [currentLocale]="currentLocale"
    (onSelect)="onProjectsSelected($event)"
    (onClose)="closeProjectSelector()">
  </app-project-selector-modal>

  <!-- Text Editor Modal for Grid Cell Components -->
  <div *ngIf="showTextEditorModal" class="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 p-4"
       (click)="showTextEditorModal = false">
    <div class="bg-gray-800 rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col"
         (click)="$event.stopPropagation()">
      <!-- Modal Header -->
      <div class="flex items-center justify-between p-6 border-b border-gray-700">
        <h3 class="text-lg font-semibold text-white">Tekst Bewerken</h3>
        <button
          (click)="showTextEditorModal = false"
          class="text-gray-400 hover:text-white transition-colors">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <!-- Modal Body -->
      <div class="flex-1 overflow-y-auto p-6">
        <editor
          *ngIf="showTextEditorModal"
          [(ngModel)]="cellComponentContent"
          (ngModelChange)="onCellComponentContentChange($event)"
          [init]="editorConfig"
          class="w-full">
        </editor>
      </div>
      
      <!-- Modal Footer -->
      <div class="flex items-center justify-end space-x-3 p-6 border-t border-gray-700">
        <button
          (click)="showTextEditorModal = false"
          class="px-4 py-2 text-sm font-medium text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors">
          Annuleren
        </button>
        <button
          (click)="saveCellComponentContent()"
          class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors">
          Opslaan
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Reusable Styling Options Template -->
<ng-template #sectionStylingTemplate>
  <div class="border-t border-gray-700 pt-6 mt-6">
    <h3 class="text-sm font-semibold text-gray-200 mb-4">Styling Opties</h3>

    <!-- Title (niet tonen voor title component — heeft eigen velden) -->
    <div *ngIf="getSelectedComponent()?.type !== 'title'" class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Titel</label>
      <input
        type="text"
        [value]="getSelectedComponent()?.data?.['heading'] || ''"
        (input)="updateTextComponentField('heading', $any($event.target).value)"
        placeholder="Sectie titel"
        class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
          hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
    </div>

    <!-- Subtitle (niet tonen voor title component) -->
    <div *ngIf="getSelectedComponent()?.type !== 'title'" class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel</label>
      <input
        type="text"
        [value]="getSelectedComponent()?.data?.['subtitle'] || ''"
        (input)="updateTextComponentField('subtitle', $any($event.target).value)"
        placeholder="Optionele subtitel"
        class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
          hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
    </div>

    <!-- Subtitle Position (niet tonen voor title component) -->
    <div *ngIf="getSelectedComponent()?.type !== 'title' && getSelectedComponent()?.data?.['subtitle']" class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel Positie</label>
      <select
        [value]="getSelectedComponent()?.data?.['subtitlePosition'] || 'below'"
        (change)="updateTextComponentField('subtitlePosition', $any($event.target).value)"
        class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
          hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <option value="above">Boven de titel</option>
        <option value="below">Onder de titel</option>
      </select>
    </div>

    <!-- Title Position (niet tonen voor title component) -->
    <div *ngIf="getSelectedComponent()?.type !== 'title'" class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Titel Positie</label>
      <select
        [value]="getSelectedComponent()?.data?.['titlePosition'] || 'left'"
        (change)="updateTextComponentField('titlePosition', $any($event.target).value)"
        class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
          hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <option value="left">Links</option>
        <option value="center">Gecentreerd</option>
        <option value="right">Rechts</option>
      </select>
    </div>

    <!-- Background Type -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Achtergrond Type</label>
      <select
        [value]="getSelectedComponent()?.data?.['backgroundType'] || 'solid'"
        (change)="updateTextComponentField('backgroundType', $any($event.target).value)"
        class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
          hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <option value="solid">Vaste Kleur</option>
        <option value="theme">Thema Accent</option>
        <option value="gradient">Gradient</option>
        <option value="image">Afbeelding</option>
      </select>
    </div>

    <!-- Theme Accent Background -->
    <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'theme'" class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Thema Accent</label>
      <p class="text-xs text-gray-400 mb-3">Kies een achtergrondkleur gebaseerd op je website thema. Past zich automatisch aan wanneer het thema wijzigt.</p>
      <div class="grid grid-cols-2 gap-2">
        <button type="button"
          (click)="updateTextComponentField('themeAccent', 'primary')"
          [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'primary'"
          [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'primary'"
          class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
          <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: var(--primary-color, #2563eb)"></span>
          <span class="text-xs text-gray-300">Primary</span>
        </button>
        <button type="button"
          (click)="updateTextComponentField('themeAccent', 'accent')"
          [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'accent'"
          [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'accent'"
          class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
          <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: var(--accent-color, #0ea5e9)"></span>
          <span class="text-xs text-gray-300">Accent</span>
        </button>
        <button type="button"
          (click)="updateTextComponentField('themeAccent', 'primary-light')"
          [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-light'"
          [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-light'"
          class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
          <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: color-mix(in srgb, var(--primary-color, #2563eb) 12%, white)"></span>
          <span class="text-xs text-gray-300">Primary Licht</span>
        </button>
        <button type="button"
          (click)="updateTextComponentField('themeAccent', 'accent-light')"
          [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'accent-light'"
          [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'accent-light'"
          class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
          <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: color-mix(in srgb, var(--accent-color, #0ea5e9) 12%, white)"></span>
          <span class="text-xs text-gray-300">Accent Licht</span>
        </button>
        <button type="button"
          (click)="updateTextComponentField('themeAccent', 'dark')"
          [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'dark'"
          [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'dark'"
          class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
          <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: #111827"></span>
          <span class="text-xs text-gray-300">Donker</span>
        </button>
        <button type="button"
          (click)="updateTextComponentField('themeAccent', 'light')"
          [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'light'"
          [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'light'"
          class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left">
          <span class="w-6 h-6 rounded-full flex-shrink-0" style="background-color: #f9fafb"></span>
          <span class="text-xs text-gray-300">Licht Grijs</span>
        </button>
        <button type="button"
          (click)="updateTextComponentField('themeAccent', 'primary-gradient')"
          [class.ring-2]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-gradient'"
          [class.ring-indigo-400]="getSelectedComponent()?.data?.['themeAccent'] === 'primary-gradient'"
          class="flex items-center gap-2 p-2.5 rounded-lg bg-gray-800 border border-gray-600 hover:border-gray-500 transition-all text-left col-span-2">
          <span class="w-6 h-6 rounded-full flex-shrink-0" style="background: linear-gradient(135deg, var(--primary-color, #2563eb), var(--accent-color, #0ea5e9))"></span>
          <span class="text-xs text-gray-300">Primary → Accent Gradient</span>
        </button>
      </div>
    </div>

    <!-- Solid Color Background -->
    <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'solid'" class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Achtergrond Kleur</label>
      <div class="flex items-center space-x-2">
        <input
          type="color"
          [value]="getSelectedComponent()?.data?.['backgroundColor'] || '#ffffff'"
          (change)="updateTextComponentField('backgroundColor', $any($event.target).value)"
          class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
        <input
          type="text"
          [value]="getSelectedComponent()?.data?.['backgroundColor'] || '#ffffff'"
          (input)="updateTextComponentField('backgroundColor', $any($event.target).value)"
          class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
            hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
      </div>
    </div>

    <!-- Gradient Background -->
    <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'gradient'" class="mb-4 space-y-3">
      <div>
        <label class="block text-sm font-medium text-gray-300 mb-2">Gradient Van</label>
        <div class="flex items-center space-x-2">
          <input
            type="color"
            [value]="getSelectedComponent()?.data?.['gradientFrom'] || '#ffffff'"
            (change)="updateTextComponentField('gradientFrom', $any($event.target).value)"
            class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
          <input
            type="text"
            [value]="getSelectedComponent()?.data?.['gradientFrom'] || '#ffffff'"
            (input)="updateTextComponentField('gradientFrom', $any($event.target).value)"
            class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
              hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        </div>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-300 mb-2">Gradient Naar</label>
        <div class="flex items-center space-x-2">
          <input
            type="color"
            [value]="getSelectedComponent()?.data?.['gradientTo'] || '#ffffff'"
            (change)="updateTextComponentField('gradientTo', $any($event.target).value)"
            class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
          <input
            type="text"
            [value]="getSelectedComponent()?.data?.['gradientTo'] || '#ffffff'"
            (input)="updateTextComponentField('gradientTo', $any($event.target).value)"
            class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
              hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        </div>
      </div>
    </div>

    <!-- Image Background -->
    <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'image'" class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Achtergrond Afbeelding</label>
      <div class="space-y-2">
        <button
          type="button"
          (click)="openMediaSelector()"
          class="w-full inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-600">
          <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Selecteer uit Media Bibliotheek
        </button>
        <input
          type="text"
          [value]="getSelectedComponent()?.data?.['backgroundImage'] || ''"
          (input)="updateTextComponentField('backgroundImage', $any($event.target).value)"
          placeholder="Of voer URL in..."
          class="w-full rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
            hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <div *ngIf="getSelectedComponent()?.data?.['backgroundImage']" class="mt-2">
          <img
            [src]="getSelectedComponent()?.data?.['backgroundImage']"
            alt="Preview"
            class="w-full h-32 object-cover rounded-lg border border-gray-600">
        </div>
      </div>
    </div>

    <!-- Parallax (only for image background) -->
    <div *ngIf="(getSelectedComponent()?.data?.['backgroundType'] || 'solid') === 'image'" class="mb-4">
      <label class="flex items-center space-x-2 cursor-pointer">
        <input
          type="checkbox"
          [checked]="getSelectedComponent()?.data?.['parallax'] || false"
          (change)="updateTextComponentField('parallax', $any($event.target).checked)"
          class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-2">
        <span class="text-sm font-medium text-gray-300">Parallax Effect</span>
      </label>
      <p class="mt-1 text-xs text-gray-400">Maakt de achtergrond vast tijdens scrollen</p>
    </div>

    <!-- Section Height -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Sectie Hoogte</label>
      <div class="flex items-center space-x-2">
        <input
          type="number"
          [value]="getSelectedComponent()?.data?.['sectionHeight'] || ''"
          (input)="updateTextComponentField('sectionHeight', $any($event.target).value)"
          placeholder="Auto"
          min="0"
          class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
            hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <select
          [value]="getSelectedComponent()?.data?.['heightUnit'] || 'px'"
          (change)="updateTextComponentField('heightUnit', $any($event.target).value)"
          class="rounded-lg bg-gray-700 border-transparent px-3 py-2 text-sm text-gray-200
            hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
          <option value="px">px</option>
          <option value="vh">vh</option>
        </select>
      </div>
      <p class="mt-1 text-xs text-gray-400">Laat leeg voor automatische hoogte</p>
    </div>

    <!-- Spacing (compact collapsible) -->
    <div class="mt-6 rounded-lg bg-gray-700/40 border border-gray-700">
      <!-- Padding header -->
      <button type="button" (click)="showPaddingEditor = !showPaddingEditor"
        class="w-full flex items-center justify-between px-3 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider hover:text-gray-200 transition-colors">
        <span class="flex items-center gap-2">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
          </svg>
          Padding
        </span>
        <div class="flex items-center gap-2">
          <span *ngIf="getSelectedComponent()?.data?.['paddingTop'] != null || getSelectedComponent()?.data?.['paddingBottom'] != null || getSelectedComponent()?.data?.['paddingX'] != null"
            class="text-[10px] text-indigo-400 font-mono normal-case">
            {{ getSelectedComponent()?.data?.['paddingTop'] != null ? getSelectedComponent()?.data?.['paddingTop'] + 'px' : '-' }} · {{ getSelectedComponent()?.data?.['paddingX'] != null ? getSelectedComponent()?.data?.['paddingX'] + 'px' : '-' }} · {{ getSelectedComponent()?.data?.['paddingBottom'] != null ? getSelectedComponent()?.data?.['paddingBottom'] + 'px' : '-' }}
          </span>
          <svg class="w-3.5 h-3.5 transition-transform" [class.rotate-180]="showPaddingEditor" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>
      <div *ngIf="showPaddingEditor" class="px-3 pb-3 space-y-2 border-t border-gray-700">
        <div class="flex items-center gap-2 mt-2">
          <span class="text-[10px] text-gray-500 w-8">Boven</span>
          <input type="range" min="0" max="160" step="4" [value]="getSelectedComponent()?.data?.['paddingTop'] ?? ''" (input)="updateTextComponentField('paddingTop', $any($event.target).value !== '' ? +$any($event.target).value : null)" class="flex-1 accent-indigo-500 h-1">
          <input type="number" min="0" max="300" step="4" [value]="getSelectedComponent()?.data?.['paddingTop'] ?? ''" (input)="updateTextComponentField('paddingTop', $any($event.target).value !== '' ? +$any($event.target).value : null)" placeholder="—" class="w-14 rounded bg-gray-700 border-transparent px-1.5 py-1 text-[11px] text-gray-200 text-center">
        </div>
        <div class="flex items-center gap-2">
          <span class="text-[10px] text-gray-500 w-8">Onder</span>
          <input type="range" min="0" max="160" step="4" [value]="getSelectedComponent()?.data?.['paddingBottom'] ?? ''" (input)="updateTextComponentField('paddingBottom', $any($event.target).value !== '' ? +$any($event.target).value : null)" class="flex-1 accent-indigo-500 h-1">
          <input type="number" min="0" max="300" step="4" [value]="getSelectedComponent()?.data?.['paddingBottom'] ?? ''" (input)="updateTextComponentField('paddingBottom', $any($event.target).value !== '' ? +$any($event.target).value : null)" placeholder="—" class="w-14 rounded bg-gray-700 border-transparent px-1.5 py-1 text-[11px] text-gray-200 text-center">
        </div>
        <div class="flex items-center gap-2">
          <span class="text-[10px] text-gray-500 w-8">L / R</span>
          <input type="range" min="0" max="160" step="4" [value]="getSelectedComponent()?.data?.['paddingX'] ?? ''" (input)="updateTextComponentField('paddingX', $any($event.target).value !== '' ? +$any($event.target).value : null)" class="flex-1 accent-indigo-500 h-1">
          <input type="number" min="0" max="300" step="4" [value]="getSelectedComponent()?.data?.['paddingX'] ?? ''" (input)="updateTextComponentField('paddingX', $any($event.target).value !== '' ? +$any($event.target).value : null)" placeholder="—" class="w-14 rounded bg-gray-700 border-transparent px-1.5 py-1 text-[11px] text-gray-200 text-center">
        </div>
      </div>

      <!-- Margin header -->
      <button type="button" (click)="showMarginEditor = !showMarginEditor"
        class="w-full flex items-center justify-between px-3 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider hover:text-gray-200 transition-colors border-t border-gray-700">
        <span class="flex items-center gap-2">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
          Margin
        </span>
        <div class="flex items-center gap-2">
          <span *ngIf="getSelectedComponent()?.data?.['marginTop'] != null || getSelectedComponent()?.data?.['marginBottom'] != null"
            class="text-[10px] text-indigo-400 font-mono normal-case">
            {{ getSelectedComponent()?.data?.['marginTop'] != null ? getSelectedComponent()?.data?.['marginTop'] + 'px' : '-' }} · {{ getSelectedComponent()?.data?.['marginBottom'] != null ? getSelectedComponent()?.data?.['marginBottom'] + 'px' : '-' }}
          </span>
          <svg class="w-3.5 h-3.5 transition-transform" [class.rotate-180]="showMarginEditor" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>
      <div *ngIf="showMarginEditor" class="px-3 pb-3 space-y-2 border-t border-gray-700">
        <div class="flex items-center gap-2 mt-2">
          <span class="text-[10px] text-gray-500 w-8">Boven</span>
          <input type="range" min="0" max="160" step="4" [value]="getSelectedComponent()?.data?.['marginTop'] ?? ''" (input)="updateTextComponentField('marginTop', $any($event.target).value !== '' ? +$any($event.target).value : null)" class="flex-1 accent-indigo-500 h-1">
          <input type="number" min="0" max="300" step="4" [value]="getSelectedComponent()?.data?.['marginTop'] ?? ''" (input)="updateTextComponentField('marginTop', $any($event.target).value !== '' ? +$any($event.target).value : null)" placeholder="—" class="w-14 rounded bg-gray-700 border-transparent px-1.5 py-1 text-[11px] text-gray-200 text-center">
        </div>
        <div class="flex items-center gap-2">
          <span class="text-[10px] text-gray-500 w-8">Onder</span>
          <input type="range" min="0" max="160" step="4" [value]="getSelectedComponent()?.data?.['marginBottom'] ?? ''" (input)="updateTextComponentField('marginBottom', $any($event.target).value !== '' ? +$any($event.target).value : null)" class="flex-1 accent-indigo-500 h-1">
          <input type="number" min="0" max="300" step="4" [value]="getSelectedComponent()?.data?.['marginBottom'] ?? ''" (input)="updateTextComponentField('marginBottom', $any($event.target).value !== '' ? +$any($event.target).value : null)" placeholder="—" class="w-14 rounded bg-gray-700 border-transparent px-1.5 py-1 text-[11px] text-gray-200 text-center">
        </div>
      </div>
    </div>

    <!-- Kleuren -->
    <h4 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3 mt-6">Kleuren</h4>
    <p class="text-xs text-gray-500 mb-4">Laat leeg om de standaard theme-kleuren te gebruiken</p>

    <!-- Heading Color -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Titel Kleur</label>
      <div class="flex items-center space-x-2">
        <input
          type="color"
          [value]="getSelectedComponent()?.data?.['headingColor'] || '#111827'"
          (change)="updateTextComponentField('headingColor', $any($event.target).value)"
          class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
        <input
          type="text"
          [value]="getSelectedComponent()?.data?.['headingColor'] || ''"
          (input)="updateTextComponentField('headingColor', $any($event.target).value)"
          placeholder="Theme standaard"
          class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
            hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <button *ngIf="getSelectedComponent()?.data?.['headingColor']"
          type="button"
          (click)="updateTextComponentField('headingColor', '')"
          title="Reset naar theme standaard"
          class="p-2 text-gray-400 hover:text-white transition-colors">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Subtitle Color -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Subtitel Kleur</label>
      <div class="flex items-center space-x-2">
        <input
          type="color"
          [value]="getSelectedComponent()?.data?.['subtitleColor'] || '#6b7280'"
          (change)="updateTextComponentField('subtitleColor', $any($event.target).value)"
          class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
        <input
          type="text"
          [value]="getSelectedComponent()?.data?.['subtitleColor'] || ''"
          (input)="updateTextComponentField('subtitleColor', $any($event.target).value)"
          placeholder="Theme standaard"
          class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
            hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <button *ngIf="getSelectedComponent()?.data?.['subtitleColor']"
          type="button"
          (click)="updateTextComponentField('subtitleColor', '')"
          title="Reset naar theme standaard"
          class="p-2 text-gray-400 hover:text-white transition-colors">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Text Color -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-300 mb-2">Tekst Kleur</label>
      <div class="flex items-center space-x-2">
        <input
          type="color"
          [value]="getSelectedComponent()?.data?.['textColor'] || '#374151'"
          (change)="updateTextComponentField('textColor', $any($event.target).value)"
          class="h-10 w-20 rounded border border-gray-600 cursor-pointer">
        <input
          type="text"
          [value]="getSelectedComponent()?.data?.['textColor'] || ''"
          (input)="updateTextComponentField('textColor', $any($event.target).value)"
          placeholder="Theme standaard"
          class="flex-1 rounded-lg bg-gray-700 border-transparent px-4 py-2 text-sm text-gray-200
            hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20">
        <button *ngIf="getSelectedComponent()?.data?.['textColor']"
          type="button"
          (click)="updateTextComponentField('textColor', '')"
          title="Reset naar theme standaard"
          class="p-2 text-gray-400 hover:text-white transition-colors">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</ng-template>
